try {
  document.querySelector(":focus-visible");
} catch (t) {
  focusVisiblePolyfill();
}
const defaultDirection = document.currentScript && document.currentScript.dataset.isRtl === "true" ? "rtl" : "ltr";
const isRtl = defaultDirection === "rtl";
function focusVisiblePolyfill() {
  let t = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
  let e = null;
  let i = null;
  window.addEventListener("keydown", e => {
    if (t.includes(e.code.toUpperCase())) {
      i = false;
    }
  });
  window.addEventListener("mousedown", t => {
    i = true;
  });
  window.addEventListener("focus", () => {
    if (e) {
      e.classList.remove("focused");
    }
    if (!i) {
      (e = document.activeElement).classList.add("focused");
    }
  }, true);
}
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let t = (t, e) => {
      if (t[0].isIntersecting) {
        e.unobserve(this);
        if (this.dataset.loaded !== "true") {
          this.loadProducts();
        }
      }
    };
    new IntersectionObserver(t.bind(this), {
      rootMargin: "0px 0px 400px 0px"
    }).observe(this);
  }
  loadProducts() {
    if (this.dataset.loaded !== "true") {
      fetch(this.dataset.url).then(t => t.text()).then(t => {
        let e = document.createElement("div");
        e.innerHTML = t;
        let i = e.querySelector("product-recommendations");
        let s = "";
        if (i && i.innerHTML.trim().length) {
          s = i.innerHTML;
          if (this.dataset.isUpsellBlock === "true" && !s.includes("-upsell") && !s.includes("data-selected")) {
            s = "";
          }
        }
        if (s.trim().length) {
          this.innerHTML = s;
          if (this.dataset.isUpsellBlock === "true") {
            if (i.classList.contains("upsells-container--stacked-columns")) {
              this.classList.add("upsells-container--stacked-columns");
            }
            if (i.classList.contains("side-margins-negative")) {
              this.classList.add("side-margins-negative");
            }
            this.dataset.count = i.dataset.count;
            getComputedStyle(i);
            getComputedStyle(i).getPropertyValue("--item-count");
            this.style.setProperty("--item-count", i.dataset.count);
          }
        }
        if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
          this.remove();
        }
        if (e.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
        this.dataset.loaded = "true";
      }).catch(t => {
        console.error(t);
      });
    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach(t => t.addEventListener("click", this.onSummaryClick.bind(this)));
    this.querySelectorAll("button:not(.menu-drawer__close-menu-btn)").forEach(t => t.addEventListener("click", this.onCloseButtonClick.bind(this)));
  }
  onKeyUp(t) {
    if (t.code.toUpperCase() !== "ESCAPE") {
      return;
    }
    let e = t.target.closest("details[open]");
    if (e) {
      if (e === this.mainDetailsToggle) {
        this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector("summary"));
      } else {
        this.closeSubmenu(e);
      }
    }
  }
  onSummaryClick(t) {
    let e = t.currentTarget;
    let i = e.parentNode;
    let s = i.closest(".has-submenu");
    let n = i.hasAttribute("open");
    let o = window.matchMedia("(prefers-reduced-motion: reduce)");
    function r() {
      trapFocus(e.nextElementSibling, i.querySelector("button"));
      e.nextElementSibling.removeEventListener("transitionend", r);
    }
    if (i === this.mainDetailsToggle) {
      if (n) {
        t.preventDefault();
      }
      if (n) {
        this.closeMenuDrawer(t, e);
      } else {
        this.openMenuDrawer(e);
      }
      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        i.classList.add("menu-opening");
        e.setAttribute("aria-expanded", true);
        if (s) {
          s.classList.add("submenu-open");
        }
        if (!o || o.matches) {
          r();
        } else {
          e.nextElementSibling.addEventListener("transitionend", r);
        }
      }, 100);
    }
  }
  openMenuDrawer(t) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    t.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, t);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(t, e = false) {
    if (t !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach(t => {
        t.removeAttribute("open");
        t.classList.remove("menu-opening");
      });
      this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach(t => {
        t.classList.remove("submenu-open");
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(e);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }
  onFocusOut(t) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement)) {
        this.closeMenuDrawer();
      }
    });
  }
  onCloseButtonClick(t) {
    let e = t.currentTarget.closest("details");
    this.closeSubmenu(e);
  }
  closeSubmenu(t) {
    let e = t.closest(".submenu-open");
    if (e) {
      e.classList.remove("submenu-open");
    }
    t.classList.remove("menu-opening");
    t.querySelector("summary").setAttribute("aria-expanded", false);
    removeTrapFocus(t.querySelector("summary"));
    this.closeAnimation(t);
  }
  closeAnimation(t) {
    let e;
    let i = s => {
      if (e === undefined) {
        e = s;
      }
      let n = s - e;
      if (n < 400) {
        window.requestAnimationFrame(i);
      } else {
        t.removeAttribute("open");
        if (t.closest("details[open]")) {
          trapFocus(t.closest("details[open]"), t.querySelector("summary"));
        }
      }
    };
    window.requestAnimationFrame(i);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.querySelectorAll(".menu-drawer__close-menu-btn").forEach(t => t.addEventListener("click", this.closeButtonClick.bind(this)));
  }
  openMenuDrawer(t) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add("menu-open");
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    t.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, t);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(t, e) {
    super.closeMenuDrawer(t, e);
    this.header.classList.remove("menu-open");
  }
  closeButtonClick(t) {
    this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector("summary"));
    this.querySelector(".header__icon--menu[aria-expanded=true]").setAttribute("aria-expanded", "false");
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ProductsMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details[id^=\"ProductsMegaMenu-\"]");
    this.mainLink = this.querySelector("summary.header__menu-item");
    this.body = this.querySelector(".products-mega-menu__body");
    this.overlay = this.querySelector(".products-mega-menu__overlay");
    this.items = this.querySelectorAll("[id^=\"ProductsMegaMenu-Item\"]");
    this.links = this.querySelectorAll("[id^=\"ProductsMegaMenu-Link\"]");
    this.mainLink.addEventListener("mouseover", this.openMenu.bind(this));
    this.overlay.addEventListener("mouseover", this.closeMenu.bind(this));
    this.overlay.addEventListener("click", this.closeMenu.bind(this));
    document.addEventListener("click", this.outsideClick.bind(this));
    this.links.forEach(t => {
      t.addEventListener("mouseover", this.displayContent.bind(this));
    });
  }
  displayContent(t) {
    this.items.forEach(t => {
      t.classList.remove("products-mega-menu__item--active");
    });
    t.target.closest("[id^=\"ProductsMegaMenu-Item\"]").classList.add("products-mega-menu__item--active");
  }
  openMenu() {
    document.querySelectorAll("[id^=\"Details-HeaderMenu\"], [id^=\"ProductsMegaMenu-\"]").forEach(t => {
      t.removeAttribute("open");
    });
    this.details.setAttribute("open", "");
  }
  closeMenu() {
    this.details.removeAttribute("open");
  }
  outsideClick(t) {
    if (this.details.hasAttribute("open") && t.target != this.body) {
      if (!this.body.contains(t.target)) {
        this.closeMenu();
      }
    }
  }
}
customElements.define("products-mega-menu", ProductsMegaMenu);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector("[id^=\"ModalClose-\"]").addEventListener("click", this.hide.bind(this, false));
    this.addEventListener("keyup", t => {
      if (t.code.toUpperCase() === "ESCAPE") {
        this.hide();
      }
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", t => {
        if (t.pointerType === "mouse" && !t.target.closest("deferred-media, product-model")) {
          this.hide();
        }
      });
    } else {
      this.addEventListener("click", t => {
        if (t.target === this) {
          this.hide();
        }
      });
    }
  }
  connectedCallback() {
    if (!this.moved) {
      this.moved = true;
      document.body.appendChild(this);
    }
  }
  show(t) {
    this.openedBy = t;
    let e = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (e) {
      e.loadContent();
    }
    trapFocus(this, this.querySelector("[role=\"dialog\"]"));
    window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    let t = this.querySelector("button:not(.internal-video__play, .internal-video__sound-btn)");
    if (!t) {
      return;
    }
    t.addEventListener("click", () => {
      let e = document.querySelector(this.getAttribute("data-modal"));
      if (e) {
        e.show(t);
      }
    });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    let t = this.querySelector("[id^=\"Deferred-Poster-\"]");
    if (!t) {
      return;
    }
    t.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(t = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      let e = document.createElement("div");
      e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));
      this.setAttribute("loaded", true);
      let i = this.appendChild(e.querySelector("video, model-viewer, iframe"));
      if (t) {
        i.focus();
      }
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class CopyButton extends HTMLElement {
  constructor() {
    super();
    this.textarea = document.createElement("textarea");
    this.textarea.classList.add("visually-hidden");
    this.textarea.value = this.dataset.content.trim();
    this.appendChild(this.textarea);
    this.addEventListener("click", this.handleClick.bind(this));
  }
  handleClick(t) {
    this.textarea.select();
    document.execCommand("copy");
    this.dataset.success = "true";
    setTimeout(() => this.dataset.success = "false", 3000);
  }
}
customElements.define("copy-button", CopyButton);
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[id^=\"Slider-\"]");
    this.sliderItems = this.querySelectorAll("[id^=\"Slide-\"]");
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pagination = document.querySelectorAll("[data-defer]");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector("button[name=\"previous\"]");
    this.nextButton = this.querySelector("button[name=\"next\"]");
    this.hasDots = false;
    this.scrollMultiplier = isRtl ? -1 : 1;
    this.verticalDesktop = this.dataset.desktopVertical === "true";
    this.verticalMobile = this.dataset.mobileVertical === "true";
    this.vertical = false;
    if (!this.slider || !this.nextButton) {
      return;
    }
    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    if (this.sliderControlWrapper && this.sliderControlWrapper.querySelector(".slider-counter__link")) {
      this.internalVideos = this.querySelectorAll("internal-video");
      this.pauseVideos = this.dataset.pauseVideos === "true" && this.internalVideos.length > 0;
      this.sliderFirstItemNode = this.slider.querySelector(".slider__slide");
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
      this.sliderControlLinksArray.forEach(t => t.addEventListener("click", this.linkToSlide.bind(this)));
      this.hasDots = true;
    }
    this.initPages();
    let t = new ResizeObserver(t => this.initPages());
    t.observe(this.slider);
  }
  linkToSlide(t) {
    t.preventDefault();
    let e = this.sliderControlLinksArray.indexOf(t.currentTarget);
    let i = 0;
    for (let s = 0; s < e; s++) {
      if (this.sliderControlLinksArray[s].classList.contains("hidden")) {
        i++;
      }
    }
    let n = e - i;
    let o = n + 1 - this.currentPage;
    let r = this.vertical ? this.slider.scrollTop : this.slider.scrollLeft * this.scrollMultiplier;
    let a = this.vertical ? this.sliderFirstItemNode.clientHeight : this.sliderFirstItemNode.clientWidth;
    let l = r + a * o;
    if (this.vertical) {
      this.slider.scrollTo({
        top: l,
        behavior: "smooth"
      });
    } else {
      this.slider.scrollTo({
        left: l * this.scrollMultiplier,
        behavior: "smooth"
      });
    }
  }
  initPages() {
    if (window.innerWidth < 750) {
      this.vertical = this.verticalMobile;
    } else {
      this.vertical = this.verticalDesktop;
    }
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(t => t.clientWidth > 0);
    if (!(this.sliderItemsToShow.length < 2)) {
      if (this.vertical) {
        let t = this.sliderItemsToShow[0].offsetTop;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - t;
        this.slidesPerPage = Math.floor((this.slider.clientHeight - t) / this.sliderItemOffset);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      } else {
        let e = this.sliderItemsToShow[0].offsetLeft * this.scrollMultiplier;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft * this.scrollMultiplier - e;
        this.slidesPerPage = Math.floor((this.slider.clientWidth - e) / this.sliderItemOffset);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      }
      this.update();
    }
  }
  resetPages() {
    this.sliderItems = this.querySelectorAll("[id^=\"Slide-\"]");
    this.initPages();
  }
  update() {
    if (!this.slider || !this.nextButton) {
      return;
    }
    let t = this.currentPage;
    if (this.vertical) {
      this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
    } else {
      this.currentPage = Math.round(this.slider.scrollLeft * this.scrollMultiplier / this.sliderItemOffset) + 1;
    }
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
    if (this.currentPage != t) {
      this.dispatchEvent(new CustomEvent("slideChanged", {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }
    if (this.hasDots) {
      let e = 0;
      let i = this.currentPage - 1;
      this.sliderControlLinksArray.forEach((t, s) => {
        t.classList.remove("slider-counter__link--active");
        t.removeAttribute("aria-current");
        if (!t.classList.contains("hidden")) {
          if (e === i) {
            t.classList.add("slider-counter__link--active");
            t.setAttribute("aria-current", "true");
          }
          e++;
        }
      });
    }
    let s = this.sliderItems[this.currentPage - 1];
    if (this.pauseVideos && s) {
      this.internalVideos.forEach(t => {
        if (s.id != t.closest("[id^=\"Slide-\"]").id) {
          if (t.dataset.autoplay === "true") {
            t.querySelector("video").muted = true;
            t.classList.add("internal-video--muted");
          } else {
            t.querySelector("video").pause();
            t.classList.remove("internal-video--playing");
          }
        }
      });
    }
    if (!this.enableSliderLooping) {
      if (this.vertical) {
        if (this.slider.scrollTop === 0) {
          this.prevButton.setAttribute("disabled", "disabled");
        } else {
          this.prevButton.removeAttribute("disabled");
        }
        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], true)) {
          this.nextButton.setAttribute("disabled", "disabled");
        } else {
          this.nextButton.removeAttribute("disabled");
        }
      } else {
        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
          this.prevButton.setAttribute("disabled", "disabled");
        } else {
          this.prevButton.removeAttribute("disabled");
        }
        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], true)) {
          this.nextButton.setAttribute("disabled", "disabled");
        } else {
          this.nextButton.removeAttribute("disabled");
        }
      }
    }
  }
  isSlideVisible(t, e = false, i = 0, s = false) {
    let n = e ? 10 : 0;
    if (this.vertical) {
      let o = t.offsetTop + t.clientHeight;
      let r = t.offsetTop;
      let a = this.slider.scrollTop - n + i;
      let l = this.slider.scrollTop + this.slider.clientHeight + n - i;
      return o <= l && (!s || r >= a);
    }
    {
      let d = t.offsetLeft * this.scrollMultiplier + t.clientWidth;
      let c = t.offsetLeft * this.scrollMultiplier;
      let u = this.slider.scrollLeft * this.scrollMultiplier - n + i;
      let h = this.slider.scrollLeft * this.scrollMultiplier + this.slider.clientWidth + n - i;
      return d <= h && (!s || c >= u);
    }
  }
  onButtonClick(t) {
    t.preventDefault();
    let e = t.currentTarget.dataset.step || 1;
    if (this.vertical) {
      let i = this.slider.scrollTop;
      let s;
      s = t.currentTarget.name === "next" ? i + e * this.sliderItemOffset : i - e * this.sliderItemOffset;
      this.slider.scrollTo({
        top: s,
        behavior: "smooth"
      });
    } else {
      let n = this.slider.scrollLeft * this.scrollMultiplier;
      this.slideScrollPosition = t.currentTarget.name === "next" ? n + e * this.sliderItemOffset : n - e * this.sliderItemOffset;
      this.slider.scrollTo({
        left: this.slideScrollPosition * this.scrollMultiplier
      });
    }
  }
}
customElements.define("slider-component", SliderComponent);
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.duration = parseInt(this.dataset.duration);
    this.initTimer();
    this.updateTimer();
    if (this.dataset.autoPlay === "true") {
      this.playTimer();
    }
  }
  initTimer() {
    this.innerHTML = "";
    this.minutesSpan = document.createElement("span");
    let t = document.createTextNode(":");
    this.secondsSpan = document.createElement("span");
    this.append(this.minutesSpan, t, this.secondsSpan);
  }
  updateTimer() {
    let t = parseInt(this.dataset.duration);
    if (t === 0) {
      t = 90;
    }
    let e = Math.floor(t / 60);
    let i = t % 60;
    this.minutesSpan.innerHTML = this.formatNumber(e);
    this.secondsSpan.innerHTML = this.formatNumber(i);
    this.dataset.duration = t - 1;
  }
  playTimer() {
    if (!this.isPlaying) {
      this.isPlaying = true;
      this.playInterval = setInterval(() => {
        this.updateTimer();
      }, 1000);
    }
  }
  pauseTimer() {
    clearTimeout(this.playInterval);
    this.isPlaying = true;
  }
  formatNumber(t) {
    if (t.toString().length === 1) {
      return "0" + t;
    } else {
      return t;
    }
  }
}
customElements.define("countdown-timer", CountdownTimer);
class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;
    this.scrollMultiplier = isRtl ? -1 : 1;
    if (!this.sliderControlWrapper) {
      return;
    }
    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) {
      this.currentPage = 1;
    }
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
    this.sliderControlLinksArray.forEach(t => t.addEventListener("click", this.linkToSlide.bind(this)));
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();
    if (this.slider.getAttribute("data-autoplay") === "true") {
      this.setAutoPlay();
    }
  }
  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));
    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }
  onButtonClick(t) {
    super.onButtonClick(t);
    let e = this.currentPage === 1;
    let i = this.currentPage === this.sliderItemsToShow.length;
    if (e || i) {
      if (e && t.currentTarget.name === "previous") {
        this.slideScrollPosition = this.slider.scrollLeft * this.scrollMultiplier + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (i && t.currentTarget.name === "next") {
        this.slideScrollPosition = 0;
      }
      this.slider.scrollTo({
        left: this.slideScrollPosition * this.scrollMultiplier
      });
    }
  }
  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");
    if (this.sliderControlButtons.length) {
      this.sliderControlButtons.forEach(t => {
        t.classList.remove("slider-counter__link--active");
        t.removeAttribute("aria-current");
      });
      this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
      this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true);
    }
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    } else {
      this.play();
    }
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }
  focusOutHandling(t) {
    let e = t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target);
    if (this.autoplayButtonIsSetToPlay && !e) {
      this.play();
    }
  }
  focusInHandling(t) {
    let e = t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target);
    if (e && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }
  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }
  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }
  togglePlayButtonState(t) {
    if (t) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow);
    }
  }
  autoRotateSlides() {
    let t = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft * this.scrollMultiplier + this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: t * this.scrollMultiplier
    });
  }
  setSlideVisibility() {
    this.sliderItemsToShow.forEach((t, e) => {
      let i = t.querySelectorAll("a");
      if (e === this.currentPage - 1) {
        if (i.length) {
          i.forEach(t => {
            t.removeAttribute("tabindex");
          });
        }
        t.setAttribute("aria-hidden", "false");
        t.removeAttribute("tabindex");
      } else {
        if (i.length) {
          i.forEach(t => {
            t.setAttribute("tabindex", "-1");
          });
        }
        t.setAttribute("aria-hidden", "true");
        t.setAttribute("tabindex", "-1");
      }
    });
  }
  linkToSlide(t) {
    t.preventDefault();
    let e = this.slider.scrollLeft * this.scrollMultiplier;
    let i = e + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(t.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: i * this.scrollMultiplier
    });
  }
}
function _defineProperties(t, e) {
  for (var i = 0; i < e.length; i++) {
    var s = e[i];
    s.enumerable = s.enumerable || false;
    s.configurable = true;
    if ("value" in s) {
      s.writable = true;
    }
    Object.defineProperty(t, s.key, s);
  }
}
function _createClass(t, e, i) {
  if (e) {
    _defineProperties(t.prototype, e);
  }
  if (i) {
    _defineProperties(t, i);
  }
  Object.defineProperty(t, "prototype", {
    writable: false
  });
  return t;
}
customElements.define("slideshow-component", SlideshowComponent);
(function (t, e) {
  if (typeof exports == "object" && typeof module != "undefined") {
    module.exports = e();
  } else if (typeof define == "function" && define.amd) {
    define(e);
  } else {
    (t = typeof globalThis != "undefined" ? globalThis : t || self).Splide = e();
  }
})(this, function () {
  "use strict";

  var t = "(prefers-reduced-motion: reduce)";
  function e(t) {
    t.length = 0;
  }
  function i(t, e, i) {
    return Array.prototype.slice.call(t, e, i);
  }
  function s(t) {
    return t.bind.apply(t, [null].concat(i(arguments, 1)));
  }
  var n = setTimeout;
  var o = function t() {};
  function r(t) {
    return requestAnimationFrame(t);
  }
  function a(t, e) {
    return typeof e === t;
  }
  function l(t) {
    return !p(t) && a("object", t);
  }
  var d = Array.isArray;
  var c = s(a, "function");
  var u = s(a, "string");
  var h = s(a, "undefined");
  function p(t) {
    return t === null;
  }
  function f(t) {
    try {
      return t instanceof (t.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
      return false;
    }
  }
  function v(t) {
    if (d(t)) {
      return t;
    } else {
      return [t];
    }
  }
  function m(t, e) {
    v(t).forEach(e);
  }
  function g(t, e) {
    return t.indexOf(e) > -1;
  }
  function y(t, e) {
    t.push.apply(t, v(e));
    return t;
  }
  function b(t, e, i) {
    if (t) {
      m(e, function (e) {
        if (e) {
          t.classList[i ? "add" : "remove"](e);
        }
      });
    }
  }
  function $(t, e) {
    b(t, u(e) ? e.split(" ") : e, true);
  }
  function S(t, e) {
    m(e, t.appendChild.bind(t));
  }
  function E(t, e) {
    m(t, function (t) {
      var i = (e || t).parentNode;
      if (i) {
        i.insertBefore(t, e);
      }
    });
  }
  function L(t, e) {
    return f(t) && (t.msMatchesSelector || t.matches).call(t, e);
  }
  function _(t, e) {
    var s = t ? i(t.children) : [];
    if (e) {
      return s.filter(function (t) {
        return L(t, e);
      });
    } else {
      return s;
    }
  }
  function k(t, e) {
    if (e) {
      return _(t, e)[0];
    } else {
      return t.firstElementChild;
    }
  }
  var x = Object.keys;
  function C(t, e, i) {
    if (t) {
      (i ? x(t).reverse() : x(t)).forEach(function (i) {
        if (i !== "__proto__") {
          e(t[i], i);
        }
      });
    }
    return t;
  }
  function w(t) {
    i(arguments, 1).forEach(function (e) {
      C(e, function (i, s) {
        t[s] = e[s];
      });
    });
    return t;
  }
  function A(t) {
    i(arguments, 1).forEach(function (e) {
      C(e, function (e, i) {
        if (d(e)) {
          t[i] = e.slice();
        } else if (l(e)) {
          t[i] = A({}, l(t[i]) ? t[i] : {}, e);
        } else {
          t[i] = e;
        }
      });
    });
    return t;
  }
  function M(t, e) {
    m(e || x(t), function (e) {
      delete t[e];
    });
  }
  function B(t, e) {
    m(t, function (t) {
      m(e, function (e) {
        if (t) {
          t.removeAttribute(e);
        }
      });
    });
  }
  function P(t, e, i) {
    if (l(e)) {
      C(e, function (e, i) {
        P(t, i, e);
      });
    } else {
      m(t, function (t) {
        if (p(i) || i === "") {
          B(t, e);
        } else {
          t.setAttribute(e, String(i));
        }
      });
    }
  }
  function T(t, e, i) {
    var s = document.createElement(t);
    if (e) {
      if (u(e)) {
        $(s, e);
      } else {
        P(s, e);
      }
    }
    if (i) {
      S(i, s);
    }
    return s;
  }
  function q(t, e, i) {
    if (h(i)) {
      return getComputedStyle(t)[e];
    }
    if (!p(i)) {
      t.style[e] = "" + i;
    }
  }
  function D(t, e) {
    q(t, "display", e);
  }
  function I(t) {
    if (!t.setActive || !t.setActive()) {
      t.focus({
        preventScroll: true
      });
    }
  }
  function O(t, e) {
    return t.getAttribute(e);
  }
  function H(t, e) {
    return t && t.classList.contains(e);
  }
  function N(t) {
    return t.getBoundingClientRect();
  }
  function R(t) {
    m(t, function (t) {
      if (t && t.parentNode) {
        t.parentNode.removeChild(t);
      }
    });
  }
  function W(t) {
    return k(new DOMParser().parseFromString(t, "text/html").body);
  }
  function F(t, e) {
    t.preventDefault();
    if (e) {
      t.stopPropagation();
      t.stopImmediatePropagation();
    }
  }
  function z(t, e) {
    return t && t.querySelector(e);
  }
  function V(t, e) {
    if (e) {
      return i(t.querySelectorAll(e));
    } else {
      return [];
    }
  }
  function X(t, e) {
    b(t, e, false);
  }
  function U(t) {
    return t.timeStamp;
  }
  function G(t) {
    if (u(t)) {
      return t;
    } else if (t) {
      return t + "px";
    } else {
      return "";
    }
  }
  var j = "splide";
  var Y = "data-" + j;
  function K(t, e) {
    if (!t) {
      throw Error("[" + j + "] " + (e || ""));
    }
  }
  var J = Math.min;
  var Q = Math.max;
  var Z = Math.floor;
  var tt = Math.ceil;
  var te = Math.abs;
  function ti(t, e, i) {
    return te(t - e) < i;
  }
  function ts(t, e, i, s) {
    var n = J(e, i);
    var o = Q(e, i);
    if (s) {
      return n < t && t < o;
    } else {
      return n <= t && t <= o;
    }
  }
  function tn(t, e, i) {
    var s = J(e, i);
    var n = Q(e, i);
    return J(Q(s, t), n);
  }
  function to(t) {
    return +(t > 0) - +(t < 0);
  }
  function tr(t, e) {
    m(e, function (e) {
      t = t.replace("%s", "" + e);
    });
    return t;
  }
  function ta(t) {
    if (t < 10) {
      return "0" + t;
    } else {
      return "" + t;
    }
  }
  var tl = {};
  function td() {
    var t = [];
    function i(t, e, i) {
      m(t, function (t) {
        if (t) {
          m(e, function (e) {
            e.split(" ").forEach(function (e) {
              var s = e.split(".");
              i(t, s[0], s[1]);
            });
          });
        }
      });
    }
    return {
      bind: function e(s, n, o, r) {
        i(s, n, function (e, i, s) {
          var n = "addEventListener" in e;
          var a = n ? e.removeEventListener.bind(e, i, o, r) : e.removeListener.bind(e, o);
          if (n) {
            e.addEventListener(i, o, r);
          } else {
            e.addListener(o);
          }
          t.push([e, i, s, o, a]);
        });
      },
      unbind: function e(s, n, o) {
        i(s, n, function (e, i, s) {
          t = t.filter(function (t) {
            return t[0] !== e || t[1] !== i || t[2] !== s || !!o && t[3] !== o || (t[4](), false);
          });
        });
      },
      dispatch: function t(e, i, s) {
        var n;
        if (typeof CustomEvent == "function") {
          n = new CustomEvent(i, {
            bubbles: true,
            detail: s
          });
        } else {
          (n = document.createEvent("CustomEvent")).initCustomEvent(i, true, false, s);
        }
        e.dispatchEvent(n);
        return n;
      },
      destroy: function i() {
        t.forEach(function (t) {
          t[4]();
        });
        e(t);
      }
    };
  }
  var tc = "mounted";
  var tu = "ready";
  var th = "move";
  var tp = "moved";
  var tf = "click";
  var tv = "refresh";
  var tm = "updated";
  var tg = "resize";
  var ty = "resized";
  var tb = "scroll";
  var t$ = "scrolled";
  var tS = "destroy";
  var tE = "navigation:mounted";
  var tL = "autoplay:play";
  var t_ = "autoplay:pause";
  var tk = "lazyload:loaded";
  function tx(t) {
    var e = t ? t.event.bus : document.createDocumentFragment();
    var n = td();
    if (t) {
      t.event.on(tS, n.destroy);
    }
    return w(n, {
      bus: e,
      on: function t(i, s) {
        n.bind(e, v(i).join(" "), function (t) {
          s.apply(s, d(t.detail) ? t.detail : []);
        });
      },
      off: s(n.unbind, e),
      emit: function t(s) {
        n.dispatch(e, s, i(arguments, 1));
      }
    });
  }
  function tC(t, e, i, s) {
    var n;
    var o;
    var a = Date.now;
    var l = 0;
    var d = true;
    var c = 0;
    function u() {
      if (!d) {
        l = t ? J((a() - n) / t, 1) : 1;
        if (i) {
          i(l);
        }
        if (l >= 1 && (e(), n = a(), s && ++c >= s)) {
          return h();
        }
        o = r(u);
      }
    }
    function h() {
      d = true;
    }
    function p() {
      if (o) {
        cancelAnimationFrame(o);
      }
      l = 0;
      o = 0;
      d = true;
    }
    function f(e) {
      t = e;
    }
    function v() {
      return d;
    }
    return {
      start: function e(i) {
        if (!i) {
          p();
        }
        n = a() - (i ? l * t : 0);
        d = false;
        o = r(u);
      },
      rewind: function t() {
        n = a();
        l = 0;
        if (i) {
          i(l);
        }
      },
      pause: h,
      cancel: p,
      set: f,
      isPaused: v
    };
  }
  var tw = "Arrow";
  var tA = tw + "Left";
  var tM = tw + "Right";
  var tB = tw + "Up";
  var t8 = tw + "Down";
  var tP = {
    width: ["height"],
    left: ["top", "right"],
    right: ["bottom", "left"],
    x: ["y"],
    X: ["Y"],
    Y: ["X"],
    ArrowLeft: [tB, tM],
    ArrowRight: [t8, tA]
  };
  var tT = "role";
  var tq = "tabindex";
  var tD = "aria-";
  var tI = tD + "controls";
  var tO = tD + "current";
  var tH = tD + "selected";
  var tN = tD + "label";
  var tR = tD + "labelledby";
  var tW = tD + "hidden";
  var tF = tD + "orientation";
  var t2 = tD + "roledescription";
  var tz = tD + "live";
  var tV = tD + "busy";
  var t3 = tD + "atomic";
  var t9 = [tT, tq, "disabled", tI, tO, tN, tR, tW, tF, t2];
  var tX = j + "__";
  var t0 = j;
  var t1 = tX + "track";
  var t4 = tX + "list";
  var tU = tX + "slide";
  var tG = tU + "--clone";
  var tj = tU + "__container";
  var t6 = tX + "arrows";
  var tY = tX + "arrow";
  var t5 = tY + "--prev";
  var t7 = tY + "--next";
  var tK = tX + "pagination";
  var tJ = tK + "__page";
  var tQ = tX + "progress__bar";
  var tZ = tX + "toggle";
  var et = tX + "sr";
  var ee = "is-active";
  var ei = "is-prev";
  var es = "is-next";
  var en = "is-visible";
  var eo = "is-loading";
  var er = "is-focus-in";
  var ea = "is-overflow";
  var el = [ee, en, ei, es, eo, er, ea];
  var ed = "touchstart mousedown";
  var ec = "touchmove mousemove";
  var eu = "touchend touchcancel mouseup click";
  var eh = "slide";
  var ep = "loop";
  var ef = "fade";
  var ev = Y + "-interval";
  var em = {
    passive: false,
    capture: true
  };
  var eg = {
    Spacebar: " ",
    Right: tM,
    Left: tA,
    Up: tB,
    Down: t8
  };
  function ey(t) {
    return eg[t = u(t) ? t : t.key] || t;
  }
  var eb = "keydown";
  var e$ = Y + "-lazy";
  var eS = e$ + "-srcset";
  var eE = "[" + e$ + "], [" + eS + "]";
  var eL = [" ", "Enter"];
  var e_ = Object.freeze({
    __proto__: null,
    Media: function e(i, s, n) {
      var o = i.state;
      var r = n.breakpoints || {};
      var a = n.reducedMotion || {};
      var l = td();
      var d = [];
      function c(t) {
        if (t) {
          l.destroy();
        }
      }
      function u(t, e) {
        var i = matchMedia(e);
        l.bind(i, "change", h);
        d.push([t, i]);
      }
      function h() {
        var t = o.is(7);
        var e = n.direction;
        var s = d.reduce(function (t, e) {
          return A(t, e[1].matches ? e[0] : {});
        }, {});
        M(n);
        p(s);
        if (n.destroy) {
          i.destroy(n.destroy === "completely");
        } else if (t) {
          c(true);
          i.mount();
        } else if (e !== n.direction) {
          i.refresh();
        }
      }
      function p(t, e, s) {
        A(n, t);
        if (e) {
          A(Object.getPrototypeOf(n), t);
        }
        if (s || !o.is(1)) {
          i.emit(tm, n);
        }
      }
      return {
        setup: function e() {
          var i = n.mediaQuery === "min";
          x(r).sort(function (t, e) {
            if (i) {
              return +t - +e;
            } else {
              return +e - +t;
            }
          }).forEach(function (t) {
            u(r[t], "(" + (i ? "min" : "max") + "-width:" + t + "px)");
          });
          u(a, t);
          h();
        },
        destroy: c,
        reduce: function e(i) {
          if (matchMedia(t).matches) {
            if (i) {
              A(n, a);
            } else {
              M(n, x(a));
            }
          }
        },
        set: p
      };
    },
    Direction: function t(e, i, s) {
      return {
        resolve: function t(e, i, n) {
          var o = (n = n || s.direction) !== "rtl" || i ? n === "ttb" ? 0 : -1 : 1;
          return tP[e] && tP[e][o] || e.replace(/width|left|right/i, function (t, e) {
            var i = tP[t.toLowerCase()][o] || t;
            if (e > 0) {
              return i.charAt(0).toUpperCase() + i.slice(1);
            } else {
              return i;
            }
          });
        },
        orient: function t(e) {
          return e * (s.direction === "rtl" ? 1 : -1);
        }
      };
    },
    Elements: function t(i, s, n) {
      var o;
      var r;
      var a;
      var l = tx(i);
      var d = l.on;
      var u = l.bind;
      var h = i.root;
      var p = n.i18n;
      var f = {};
      var v = [];
      var m = [];
      var g = [];
      function S() {
        var t;
        var e;
        var i;
        o = A("." + t1);
        r = k(o, "." + t4);
        K(o && r, "A track/list element is missing.");
        y(v, _(r, "." + tU + ":not(." + tG + ")"));
        C({
          arrows: t6,
          pagination: tK,
          prev: t5,
          next: t7,
          bar: tQ,
          toggle: tZ
        }, function (t, e) {
          f[e] = A("." + t);
        });
        w(f, {
          root: h,
          track: o,
          list: r,
          slides: v
        });
        e = h.id || "" + (t = j) + ta(tl[t] = (tl[t] || 0) + 1);
        i = n.role;
        h.id = e;
        o.id = o.id || e + "-track";
        r.id = r.id || e + "-list";
        if (!O(h, tT) && h.tagName !== "SECTION" && i) {
          P(h, tT, i);
        }
        P(h, t2, p.carousel);
        P(r, tT, "presentation");
        x();
      }
      function E(t) {
        var i = t9.concat("style");
        e(v);
        X(h, m);
        X(o, g);
        B([o, r], i);
        B(h, t ? i : ["style", t2]);
      }
      function x() {
        X(h, m);
        X(o, g);
        m = M(t0);
        g = M(t1);
        $(h, m);
        $(o, g);
        P(h, tN, n.label);
        P(h, tR, n.labelledby);
      }
      function A(t) {
        var e = z(h, t);
        if (e && function t(e, i) {
          if (c(e.closest)) {
            return e.closest(i);
          }
          for (var s = e; s && s.nodeType === 1 && !L(s, i);) {
            s = s.parentElement;
          }
          return s;
        }(e, "." + t0) === h) {
          return e;
        } else {
          return undefined;
        }
      }
      function M(t) {
        return [t + "--" + n.type, t + "--" + n.direction, n.drag && t + "--draggable", n.isNavigation && t + "--nav", t === t0 && ee];
      }
      return w(f, {
        setup: S,
        mount: function t() {
          d(tv, E);
          d(tv, S);
          d(tm, x);
          u(document, ed + " keydown", function (t) {
            a = t.type === "keydown";
          }, {
            capture: true
          });
          u(h, "focusin", function () {
            b(h, er, !!a);
          });
        },
        destroy: E
      });
    },
    Slides: function t(i, n, o) {
      var r = tx(i);
      var a = r.on;
      var l = r.emit;
      var d = r.bind;
      var h = n.Elements;
      var p = h.slides;
      var y = h.list;
      var _ = [];
      function x() {
        p.forEach(function (t, e) {
          w(t, e, -1);
        });
      }
      function C() {
        M(function (t) {
          t.destroy();
        });
        e(_);
      }
      function w(t, e, n) {
        var o = function t(e, i, n, o) {
          var r;
          var a = tx(e);
          var l = a.on;
          var d = a.emit;
          var c = a.bind;
          var u = e.Components;
          var h = e.root;
          var p = e.options;
          var f = p.isNavigation;
          var v = p.updateOnMove;
          var m = p.i18n;
          var g = p.pagination;
          var y = p.slideFocus;
          var $ = u.Direction.resolve;
          var S = O(o, "style");
          var E = O(o, tN);
          var L = n > -1;
          var _ = k(o, "." + tj);
          function x() {
            var t = e.splides.map(function (t) {
              var e = t.splide.Components.Slides.getAt(i);
              if (e) {
                return e.slide.id;
              } else {
                return "";
              }
            }).join(" ");
            P(o, tN, tr(m.slideX, (L ? n : i) + 1));
            P(o, tI, t);
            P(o, tT, y ? "button" : "");
            if (y) {
              B(o, t2);
            }
          }
          function C() {
            if (!r) {
              w();
            }
          }
          function w() {
            if (!r) {
              var t;
              var s = e.index;
              if ((t = A()) !== H(o, ee)) {
                b(o, ee, t);
                P(o, tO, f && t || "");
                d(t ? "active" : "inactive", M);
              }
              (function t() {
                var i = function t() {
                  if (e.is(ef)) {
                    return A();
                  }
                  var i = N(u.Elements.track);
                  var s = N(o);
                  var n = $("left", true);
                  var r = $("right", true);
                  return Z(i[n]) <= tt(s[n]) && Z(s[r]) <= tt(i[r]);
                }();
                var s = !i && (!A() || L);
                if (!e.state.is([4, 5])) {
                  P(o, tW, s || "");
                }
                P(V(o, p.focusableNodes || ""), tq, s ? -1 : "");
                if (y) {
                  P(o, tq, s ? -1 : 0);
                }
                if (i !== H(o, en)) {
                  b(o, en, i);
                  d(i ? "visible" : "hidden", M);
                }
                if (!i && document.activeElement === o) {
                  var n = u.Slides.getAt(e.index);
                  if (n) {
                    I(n.slide);
                  }
                }
              })();
              b(o, ei, i === s - 1);
              b(o, es, i === s + 1);
            }
          }
          function A() {
            var t = e.index;
            return t === i || p.cloneStatus && t === n;
          }
          var M = {
            index: i,
            slideIndex: n,
            slide: o,
            container: _,
            isClone: L,
            mount: function t() {
              if (!L) {
                o.id = h.id + "-slide" + ta(i + 1);
                P(o, tT, g ? "tabpanel" : "group");
                P(o, t2, m.slide);
                P(o, tN, E || tr(m.slideLabel, [i + 1, e.length]));
              }
              c(o, "click", s(d, tf, M));
              c(o, "keydown", s(d, "sk", M));
              l([tp, "sh", t$], w);
              l(tE, x);
              if (v) {
                l(th, C);
              }
            },
            destroy: function t() {
              r = true;
              a.destroy();
              X(o, el);
              B(o, t9);
              P(o, "style", S);
              P(o, tN, E || "");
            },
            update: w,
            style: function t(e, i, s) {
              q(s && _ || o, e, i);
            },
            isWithin: function t(s, n) {
              var o = te(s - i);
              if (!L && (p.rewind || e.is(ep))) {
                o = J(o, e.length - o);
              }
              return o <= n;
            }
          };
          return M;
        }(i, e, n, t);
        o.mount();
        _.push(o);
        _.sort(function (t, e) {
          return t.index - e.index;
        });
      }
      function A(t) {
        if (t) {
          return T(function (t) {
            return !t.isClone;
          });
        } else {
          return _;
        }
      }
      function M(t, e) {
        A(e).forEach(t);
      }
      function T(t) {
        return _.filter(c(t) ? t : function (e) {
          if (u(t)) {
            return L(e.slide, t);
          } else {
            return g(v(t), e.index);
          }
        });
      }
      return {
        mount: function t() {
          x();
          a(tv, C);
          a(tv, x);
        },
        destroy: C,
        update: function t() {
          M(function (t) {
            t.update();
          });
        },
        register: w,
        get: A,
        getIn: function t(e) {
          var i = n.Controller;
          var s = i.toIndex(e);
          var r = i.hasFocus() ? 1 : o.perPage;
          return T(function (t) {
            return ts(t.index, s, s + r - 1);
          });
        },
        getAt: function t(e) {
          return T(e)[0];
        },
        add: function t(e, i) {
          m(e, function (t) {
            if (u(t)) {
              t = W(t);
            }
            if (f(t)) {
              var e;
              var n;
              var r;
              var a;
              var c = p[i];
              if (c) {
                E(t, c);
              } else {
                S(y, t);
              }
              $(t, o.classes.slide);
              e = t;
              n = s(l, tg);
              if (a = (r = V(e, "img")).length) {
                r.forEach(function (t) {
                  d(t, "load error", function () {
                    if (! --a) {
                      n();
                    }
                  });
                });
              } else {
                n();
              }
            }
          });
          l(tv);
        },
        remove: function t(e) {
          R(T(e).map(function (t) {
            return t.slide;
          }));
          l(tv);
        },
        forEach: M,
        filter: T,
        style: function t(e, i, s) {
          M(function (t) {
            t.style(e, i, s);
          });
        },
        getLength: function t(e) {
          if (e) {
            return p.length;
          } else {
            return _.length;
          }
        },
        isEnough: function t() {
          return _.length > o.perPage;
        }
      };
    },
    Layout: function t(e, i, n) {
      var o;
      var r;
      var a;
      var d = tx(e);
      var c = d.on;
      var u = d.bind;
      var h = d.emit;
      var p = i.Slides;
      var f = i.Direction.resolve;
      var v = i.Elements;
      var m = v.root;
      var g = v.track;
      var y = v.list;
      var $ = p.getAt;
      var S = p.style;
      function E() {
        o = n.direction === "ttb";
        q(m, "maxWidth", G(n.width));
        q(g, f("paddingLeft"), _(false));
        q(g, f("paddingRight"), _(true));
        L(true);
      }
      function L(t) {
        var e;
        var i = N(m);
        if (t || r.width !== i.width || r.height !== i.height) {
          q(g, "height", (e = "", o && (e = k(), K(e, "height or heightRatio is missing."), e = "calc(" + e + " - " + _(false) + " - " + _(true) + ")"), e));
          S(f("marginRight"), G(n.gap));
          S("width", n.autoWidth ? null : G(n.fixedWidth) || (o ? "" : x()));
          S("height", G(n.fixedHeight) || (o ? n.autoHeight ? null : x() : k()), true);
          r = i;
          h(ty);
          if (a !== (a = P())) {
            b(m, ea, a);
            h("overflow", a);
          }
        }
      }
      function _(t) {
        var e = n.padding;
        var i = f(t ? "right" : "left");
        return e && G(e[i] || (l(e) ? 0 : e)) || "0px";
      }
      function k() {
        return G(n.height || N(y).width * n.heightRatio);
      }
      function x() {
        var t = G(n.gap);
        return "calc((100%" + (t && " + " + t) + ")/" + (n.perPage || 1) + (t && " - " + t) + ")";
      }
      function C() {
        return N(y)[f("width")];
      }
      function w(t, e) {
        var i = $(t || 0);
        if (i) {
          return N(i.slide)[f("width")] + (e ? 0 : B());
        } else {
          return 0;
        }
      }
      function A(t, e) {
        var i = $(t);
        if (i) {
          var s = N(i.slide)[f("right")];
          var n = N(y)[f("left")];
          return te(s - n) + (e ? 0 : B());
        }
        return 0;
      }
      function M(t) {
        return A(e.length - 1) - A(0) + w(0, t);
      }
      function B() {
        var t = $(0);
        return t && parseFloat(q(t.slide, f("marginRight"))) || 0;
      }
      function P() {
        return e.is(ef) || M(true) > C();
      }
      return {
        mount: function t() {
          var e;
          var i;
          E();
          u(window, "resize load", (e = s(h, tg), i = tC(0, e, null, 1), function () {
            if (i.isPaused()) {
              i.start();
            }
          }));
          c([tm, tv], E);
          c(tg, L);
        },
        resize: L,
        listSize: C,
        slideSize: w,
        sliderSize: M,
        totalSize: A,
        getPadding: function t(e) {
          return parseFloat(q(g, f("padding" + (e ? "Right" : "Left")))) || 0;
        },
        isOverflow: P
      };
    },
    Clones: function t(i, s, n) {
      var o;
      var r = tx(i);
      var a = r.on;
      var l = s.Elements;
      var d = s.Slides;
      var c = s.Direction.resolve;
      var u = [];
      function p() {
        a(tv, f);
        a([tm, tg], m);
        if (o = g()) {
          (function t(e) {
            var s = d.get().slice();
            var o = s.length;
            if (o) {
              while (s.length < e) {
                y(s, s);
              }
              y(s.slice(-e), s.slice(0, e)).forEach(function (t, r) {
                var a;
                var c;
                var h;
                var p = r < e;
                a = t.slide;
                c = r;
                h = a.cloneNode(true);
                $(h, n.classes.clone);
                h.id = i.root.id + "-clone" + ta(c + 1);
                var f = h;
                if (p) {
                  E(f, s[0].slide);
                } else {
                  S(l.list, f);
                }
                y(u, f);
                d.register(f, r - e + (p ? 0 : o), t.index);
              });
            }
          })(o);
          s.Layout.resize(true);
        }
      }
      function f() {
        v();
        p();
      }
      function v() {
        R(u);
        e(u);
        r.destroy();
      }
      function m() {
        var t = g();
        if (o !== t && (o < t || !t)) {
          r.emit(tv);
        }
      }
      function g() {
        var t = n.clones;
        if (i.is(ep)) {
          if (h(t)) {
            var e = n[c("fixedWidth")] && s.Layout.slideSize(0);
            t = e && tt(N(l.track)[c("width")] / e) || n[c("autoWidth")] && i.length || n.perPage * 2;
          }
        } else {
          t = 0;
        }
        return t;
      }
      return {
        mount: p,
        destroy: v
      };
    },
    Move: function t(e, i, s) {
      var n;
      var o = tx(e);
      var r = o.on;
      var a = o.emit;
      var l = e.state.set;
      var d = e.state;
      var c = i.Layout;
      var u = c.slideSize;
      var p = c.getPadding;
      var f = c.totalSize;
      var v = c.listSize;
      var m = c.sliderSize;
      var g = i.Direction;
      var y = g.resolve;
      var b = g.orient;
      var $ = i.Elements;
      var S = $.list;
      var E = $.track;
      var L = 0;
      function _() {
        return L;
      }
      function k() {
        if (!i.Controller.isBusy()) {
          i.Scroll.cancel();
          x(e.index);
          i.Slides.update();
        }
      }
      function x(t) {
        C(B(t, true));
      }
      function C(t, n) {
        if (!e.is(ef)) {
          if (s.paddingCalc && s.type === "slide" && !d.is(6)) {
            L = t >= s.padding.right * -1 ? 0 : m() + t - s.padding.right <= u() ? s.padding.right : s.padding.right / 2;
          }
          var o = n ? t : function t(s) {
            if (e.is(ep)) {
              var n = M(s);
              var o = n > i.Controller.getEnd();
              if (n < 0 || o) {
                s = w(s, o);
              }
            }
            return s;
          }(t);
          q(S, "transform", `translate${y("X")}(${o + L}px)`);
          if (t !== o) {
            a("sh");
          }
        }
      }
      function w(t, e) {
        var i = t - T(e);
        var s = m();
        return t - b(s * (tt(te(i) / s) || 1)) * (e ? 1 : -1);
      }
      function A() {
        C(P(), true);
        n.cancel();
      }
      function M(t) {
        for (var e = i.Slides.get(), s = 0, n = Infinity, o = 0; o < e.length; o++) {
          var r = e[o].index;
          var a = te(B(r, true) - t);
          if (a <= n) {
            n = a;
            s = r;
          } else {
            break;
          }
        }
        return s;
      }
      function B(t, i) {
        var n;
        var o;
        var r;
        var a = b(f(t - 1) - (n = t, o = s.focus, o === "center" ? (v() - u(n, true)) / 2 : +o * u(n) || 0));
        if (i) {
          r = a;
          if (s.trimSpace && e.is(eh)) {
            r = tn(r, 0, b(m(true) - v()));
          }
          return r;
        } else {
          return a;
        }
      }
      function P() {
        var t = y("left");
        return N(S)[t] - N(E)[t] + b(p(false)) - L;
      }
      function T(t) {
        return B(t ? i.Controller.getEnd() : 0, !!s.trimSpace);
      }
      return {
        mount: function t() {
          n = i.Transition;
          r([tc, ty, tm, tv], k);
        },
        move: function t(e, i, s, o) {
          var r;
          var d;
          if (e !== i && (r = e > s, d = b(w(P(), r)), r ? d >= 0 : d <= S[y("scrollWidth")] - N(E)[y("width")])) {
            A();
            C(w(P(), e > s), true);
          }
          l(4);
          a(th, i, s, e);
          n.start(i, function () {
            l(3);
            a(tp, i, s, e);
            if (o) {
              o();
            }
          });
        },
        jump: x,
        translate: C,
        shift: w,
        cancel: A,
        toIndex: M,
        toPosition: B,
        getPosition: P,
        getLimit: T,
        exceededLimit: function t(e, i) {
          i = h(i) ? P() : i;
          var s = e !== true && b(i) < b(T(false));
          var n = e !== false && b(i) > b(T(true));
          return s || n;
        },
        reposition: k
      };
    },
    Controller: function t(e, i, n) {
      var o;
      var r;
      var a;
      var l;
      var d = tx(e);
      var c = d.on;
      var p = d.emit;
      var f = i.Move;
      var v = f.getPosition;
      var m = f.getLimit;
      var g = f.toPosition;
      var y = i.Slides;
      var b = y.isEnough;
      var $ = y.getLength;
      var S = n.omitEnd;
      var E = e.is(ep);
      var L = e.is(eh);
      var _ = s(M, false);
      var k = s(M, true);
      var x = n.start || 0;
      var C = x;
      function w() {
        r = $(true);
        a = n.perMove;
        l = n.perPage;
        o = T();
        var t = tn(x, 0, S ? o : r - 1);
        if (t !== x) {
          x = t;
          f.reposition();
        }
      }
      function A() {
        if (o !== T()) {
          p("ei");
        }
      }
      function M(t, e) {
        var i;
        var s;
        var n = a || (O() ? 1 : l);
        var r = B(x + n * (t ? -1 : 1), x, !a && !O());
        if (r === -1 && L) {
          i = v();
          if (!(te(i - (s = m(!t))) < 1)) {
            if (t) {
              return 0;
            } else {
              return o;
            }
          }
        }
        if (e) {
          return r;
        } else {
          return P(r);
        }
      }
      function B(t, i, s) {
        if (b() || O()) {
          var d = function t(i) {
            if (L && n.trimSpace === "move" && i !== x) {
              for (var s = v(); s === g(i, true) && ts(i, 0, e.length - 1, !n.rewind);) {
                if (i < x) {
                  --i;
                } else {
                  ++i;
                }
              }
            }
            return i;
          }(t);
          if (d !== t) {
            i = t;
            t = d;
            s = false;
          }
          if (t < 0 || t > o) {
            t = !a && (ts(0, t, i, true) || ts(o, i, t, true)) ? q(D(t)) : E ? s ? t < 0 ? -(r % l || l) : r : t : n.rewind ? t < 0 ? o : 0 : -1;
          } else if (s && t !== i) {
            t = q(D(i) + (t < i ? -1 : 1));
          }
        } else {
          t = -1;
        }
        return t;
      }
      function P(t) {
        if (E) {
          return (t + r) % r || 0;
        } else {
          return t;
        }
      }
      function T() {
        for (var t = r - (O() || E && a ? 1 : l); S && t-- > 0;) {
          if (g(r - 1, true) !== g(t, true)) {
            t++;
            break;
          }
        }
        return tn(t, 0, r - 1);
      }
      function q(t) {
        return tn(O() ? t : l * t, 0, o);
      }
      function D(t) {
        if (O()) {
          return J(t, o);
        } else {
          return Z((t >= o ? r - 1 : t) / l);
        }
      }
      function I(t) {
        if (t !== x) {
          C = x;
          x = t;
        }
      }
      function O() {
        return !h(n.focus) || n.isNavigation;
      }
      function H() {
        return e.state.is([4, 5]) && !!n.waitForTransition;
      }
      return {
        mount: function t() {
          w();
          c([tm, tv, "ei"], w);
          c(ty, A);
        },
        go: function t(e, i, s) {
          if (!H()) {
            var n = function t(e) {
              var i = x;
              if (u(e)) {
                var s = e.match(/([+\-<>])(\d+)?/) || [];
                var n = s[1];
                var r = s[2];
                if (n === "+" || n === "-") {
                  i = B(x + +("" + n + (+r || 1)), x);
                } else if (n === ">") {
                  i = r ? q(+r) : _(true);
                } else if (n === "<") {
                  i = k(true);
                }
              } else {
                i = E ? e : tn(e, 0, o);
              }
              return i;
            }(e);
            var r = P(n);
            if (r > -1 && (i || r !== x)) {
              I(r);
              f.move(n, r, C, s);
            }
          }
        },
        scroll: function t(e, s, n, r) {
          i.Scroll.scroll(e, s, n, function () {
            var t = P(f.toIndex(v()));
            I(S ? J(t, o) : t);
            if (r) {
              r();
            }
          });
        },
        getNext: _,
        getPrev: k,
        getAdjacent: M,
        getEnd: T,
        setIndex: I,
        getIndex: function t(e) {
          if (e) {
            return C;
          } else {
            return x;
          }
        },
        toIndex: q,
        toPage: D,
        toDest: function t(e) {
          var i = f.toIndex(e);
          if (L) {
            return tn(i, 0, o);
          } else {
            return i;
          }
        },
        hasFocus: O,
        isBusy: H
      };
    },
    Arrows: function t(e, i, n) {
      var o;
      var r;
      var a = tx(e);
      var l = a.on;
      var d = a.bind;
      var c = a.emit;
      var u = n.classes;
      var h = n.i18n;
      var p = i.Elements;
      var f = i.Controller;
      var v = p.arrows;
      var m = p.track;
      var g = v;
      var y = p.prev;
      var b = p.next;
      var L = {};
      function _() {
        var t;
        if ((t = n.arrows) && (!y || !b)) {
          g = v || T("div", u.arrows);
          y = A(true);
          b = A(false);
          o = true;
          S(g, [y, b]);
          if (!v) {
            E(g, m);
          }
        }
        if (y && b) {
          w(L, {
            prev: y,
            next: b
          });
          D(g, t ? "" : "none");
          $(g, r = t6 + "--" + n.direction);
          if (t) {
            l([tc, tp, tv, t$, "ei"], M);
            d(b, "click", s(C, ">"));
            d(y, "click", s(C, "<"));
            M();
            P([y, b], tI, m.id);
            c("arrows:mounted", y, b);
          }
        }
        l(tm, k);
      }
      function k() {
        x();
        _();
      }
      function x() {
        a.destroy();
        X(g, r);
        if (o) {
          R(v ? [y, b] : g);
          y = b = null;
        } else {
          B([y, b], t9);
        }
      }
      function C(t) {
        f.go(t, true);
      }
      function A(t) {
        return W("<button class=\"" + u.arrow + " " + (t ? u.prev : u.next) + "\" type=\"button\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" width=\"40\" height=\"40\" focusable=\"false\"><path d=\"" + (n.arrowPath || "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z") + "\" />");
      }
      function M() {
        if (y && b) {
          var t = e.index;
          var i = f.getPrev();
          var s = f.getNext();
          var n = i > -1 && t < i ? h.last : h.prev;
          var o = s > -1 && t > s ? h.first : h.next;
          y.disabled = i < 0;
          b.disabled = s < 0;
          P(y, tN, n);
          P(b, tN, o);
          c("arrows:updated", y, b, i, s);
        }
      }
      return {
        arrows: L,
        mount: _,
        destroy: x,
        update: M
      };
    },
    Autoplay: function t(e, i, s) {
      var n;
      var o;
      var r = tx(e);
      var a = r.on;
      var l = r.bind;
      var d = r.emit;
      var c = tC(s.interval, e.go.bind(e, ">"), function t(e) {
        var i = h.bar;
        if (i) {
          q(i, "width", e * 100 + "%");
        }
        d("autoplay:playing", e);
      });
      var u = c.isPaused;
      var h = i.Elements;
      var p = i.Elements;
      var f = p.root;
      var v = p.toggle;
      var m = s.autoplay;
      var g = m === "pause";
      function y() {
        if (u() && i.Slides.isEnough()) {
          c.start(!s.resetProgress);
          o = n = g = false;
          E();
          d(tL);
        }
      }
      function $(t = true) {
        g = !!t;
        E();
        if (!u()) {
          c.pause();
          d(t_);
        }
      }
      function S() {
        if (!g) {
          if (n || o) {
            $(false);
          } else {
            y();
          }
        }
      }
      function E() {
        if (v) {
          b(v, ee, !g);
          P(v, tN, s.i18n[g ? "play" : "pause"]);
        }
      }
      function L(t) {
        var e = i.Slides.getAt(t);
        c.set(e && +O(e.slide, ev) || s.interval);
      }
      return {
        mount: function t() {
          if (m) {
            if (s.pauseOnHover) {
              l(f, "mouseenter mouseleave", function (t) {
                n = t.type === "mouseenter";
                S();
              });
            }
            if (s.pauseOnFocus) {
              l(f, "focusin focusout", function (t) {
                o = t.type === "focusin";
                S();
              });
            }
            if (v) {
              l(v, "click", function () {
                if (g) {
                  y();
                } else {
                  $(true);
                }
              });
            }
            a([th, tb, tv], c.rewind);
            a(th, L);
            if (v) {
              P(v, tI, h.track.id);
            }
            if (!g) {
              y();
            }
            E();
          }
        },
        destroy: c.cancel,
        play: y,
        pause: $,
        isPaused: u
      };
    },
    Cover: function t(e, i, n) {
      var o = tx(e).on;
      function r(t) {
        i.Slides.forEach(function (e) {
          var i = k(e.container || e.slide, "img");
          if (i && i.src) {
            a(t, i, e);
          }
        });
      }
      function a(t, e, i) {
        i.style("background", t ? "center/cover no-repeat url(\"" + e.src + "\")" : "", true);
        D(e, t ? "none" : "");
      }
      return {
        mount: function t() {
          if (n.cover) {
            o(tk, s(a, true));
            o([tc, tm, tv], s(r, true));
          }
        },
        destroy: s(r, false)
      };
    },
    Scroll: function t(e, i, n) {
      var o;
      var r;
      var a = tx(e);
      var l = a.on;
      var d = a.emit;
      var c = e.state.set;
      var u = i.Move;
      var h = u.getPosition;
      var p = u.getLimit;
      var f = u.exceededLimit;
      var v = u.translate;
      var m = e.is(eh);
      var g = 1;
      function y(t, e, n, a, l) {
        var p = h();
        S();
        if (n && (!m || !f())) {
          var v = i.Layout.sliderSize();
          var y = to(t) * v * Z(te(t) / v) || 0;
          t = u.toPosition(i.Controller.toDest(t % v)) + y;
        }
        var E;
        var L;
        E = p;
        L = t;
        var _ = te(E - L) < 1;
        g = 1;
        e = _ ? 0 : e || Q(te(t - p) / 1.5, 800);
        r = a;
        o = tC(e, b, s($, p, t, l), 1);
        c(5);
        d(tb);
        o.start();
      }
      function b() {
        c(3);
        if (r) {
          r();
        }
        d(t$);
      }
      function $(t, e, i, s) {
        var o;
        var a;
        var l = h();
        var d = (t + (e - t) * (o = s, a = n.easingFunc, a ? a(o) : 1 - Math.pow(1 - o, 4)) - l) * g;
        v(l + d);
        if (m && !i && f()) {
          g *= 0.6;
          if (te(d) < 10) {
            y(p(f(true)), 600, false, r, true);
          }
        }
      }
      function S() {
        if (o) {
          o.cancel();
        }
      }
      function E() {
        if (o && !o.isPaused()) {
          S();
          b();
        }
      }
      return {
        mount: function t() {
          l(th, S);
          l([tm, tv], E);
        },
        destroy: S,
        scroll: y,
        cancel: E
      };
    },
    Drag: function t(e, i, s) {
      var n;
      var r;
      var a;
      var d;
      var c;
      var u;
      var h;
      var p;
      var f = tx(e);
      var v = f.on;
      var m = f.emit;
      var g = f.bind;
      var y = f.unbind;
      var b = e.state;
      var $ = i.Move;
      var S = i.Scroll;
      var E = i.Controller;
      var _ = i.Elements.track;
      var k = i.Media.reduce;
      var x = i.Direction;
      var C = x.resolve;
      var w = x.orient;
      var A = $.getPosition;
      var M = $.exceededLimit;
      var B = false;
      function P() {
        var t;
        var e = s.drag;
        h = t = !e;
        d = e === "free";
      }
      function T(t) {
        u = false;
        if (!h) {
          var e;
          var i;
          var n = z(t);
          e = t.target;
          i = s.noDrag;
          if (!L(e, "." + tJ + ", ." + tY) && (!i || !L(e, i)) && (!!n || !t.button)) {
            if (E.isBusy()) {
              F(t, true);
            } else {
              p = n ? _ : window;
              c = b.is([4, 5]);
              a = null;
              g(p, ec, q, em);
              g(p, eu, D, em);
              $.cancel();
              S.cancel();
              O(t);
            }
          }
        }
      }
      function q(t) {
        if (!b.is(6)) {
          b.set(6);
          m("drag");
        }
        if (t.cancelable) {
          if (c) {
            $.translate(n + (p = H(t), p / (B && e.is(eh) ? 5 : 1)));
            var i;
            var o;
            var r;
            var a;
            var d;
            var h;
            var p;
            var f = N(t) > 200;
            var v = B !== (B = M());
            if (f || v) {
              O(t);
            }
            u = true;
            m("dragging");
            F(t);
          } else {
            i = t;
            if (te(H(i)) > te(H(i, true))) {
              o = t;
              r = s.dragMinThreshold;
              a = l(r);
              d = a && r.mouse || 0;
              h = (a ? r.touch : +r) || 10;
              c = te(H(o)) > (z(o) ? h : d);
              F(t);
            }
          }
        }
      }
      function D(t) {
        var n;
        var o;
        var r;
        var a;
        var l;
        if (b.is(6)) {
          b.set(3);
          m("dragged");
        }
        if (c) {
          o = r = function t(i) {
            if (e.is(ep) || !B) {
              var s = N(i);
              if (s && s < 200) {
                return H(i) / s;
              }
            }
            return 0;
          }(n = t);
          a = A() + to(o) * J(te(o) * (s.flickPower || 600), d ? Infinity : i.Layout.listSize() * (s.flickMaxPages || 1));
          l = s.rewind && s.rewindByDrag;
          k(false);
          if (d) {
            E.scroll(a, 0, s.snap);
          } else if (e.is(ef)) {
            E.go(w(to(r)) < 0 ? l ? "<" : "-" : l ? ">" : "+");
          } else if (e.is(eh) && B && l) {
            E.go(M(true) ? ">" : "<");
          } else {
            E.go(E.toDest(a), true);
          }
          k(true);
          F(t);
        }
        y(p, ec, q);
        y(p, eu, D);
        c = false;
      }
      function I(t) {
        if (!h && u) {
          F(t, true);
        }
      }
      function O(t) {
        a = r;
        r = t;
        n = A();
      }
      function H(t, e) {
        return W(t, e) - W(R(t), e);
      }
      function N(t) {
        return U(t) - U(R(t));
      }
      function R(t) {
        return r === t && a || r;
      }
      function W(t, e) {
        return (z(t) ? t.changedTouches[0] : t)["page" + C(e ? "Y" : "X")];
      }
      function z(t) {
        return typeof TouchEvent != "undefined" && t instanceof TouchEvent;
      }
      function V() {
        return c;
      }
      function X(t) {
        h = t;
      }
      return {
        mount: function t() {
          g(_, ec, o, em);
          g(_, eu, o, em);
          g(_, ed, T, em);
          g(_, "click", I, {
            capture: true
          });
          g(_, "dragstart", F);
          v([tc, tm], P);
        },
        disable: X,
        isDragging: V
      };
    },
    Keyboard: function t(e, i, s) {
      var o;
      var r;
      var a = tx(e);
      var l = a.on;
      var d = a.bind;
      var c = a.unbind;
      var u = e.root;
      var h = i.Direction.resolve;
      function p() {
        var t = s.keyboard;
        if (t) {
          d(o = t === "global" ? window : u, eb, g);
        }
      }
      function f() {
        c(o, eb);
      }
      function v(t) {
        r = t;
      }
      function m() {
        var t = r;
        r = true;
        n(function () {
          r = t;
        });
      }
      function g(t) {
        if (!r) {
          var i = ey(t);
          if (i === h(tA)) {
            e.go("<");
          } else if (i === h(tM)) {
            e.go(">");
          }
        }
      }
      return {
        mount: function t() {
          p();
          l(tm, f);
          l(tm, p);
          l(th, m);
        },
        destroy: f,
        disable: v
      };
    },
    LazyLoad: function t(i, n, o) {
      var r = tx(i);
      var a = r.on;
      var l = r.off;
      var d = r.bind;
      var c = r.emit;
      var u = o.lazyLoad === "sequential";
      var h = [tp, t$];
      var p = [];
      function f() {
        e(p);
        n.Slides.forEach(function (t) {
          V(t.slide, eE).forEach(function (e) {
            var i = O(e, e$);
            var s = O(e, eS);
            if (i !== e.src || s !== e.srcset) {
              var n = o.classes.spinner;
              var r = e.parentElement;
              var a = k(r, "." + n) || T("span", n, r);
              p.push([e, t, a]);
              if (!e.src) {
                D(e, "none");
              }
            }
          });
        });
        if (u) {
          y();
        } else {
          l(h);
          a(h, v);
          v();
        }
      }
      function v() {
        if (!(p = p.filter(function (t) {
          var e = o.perPage * ((o.preloadPages || 1) + 1) - 1;
          return !t[1].isWithin(i.index, e) || m(t);
        })).length) {
          l(h);
        }
      }
      function m(t) {
        var e = t[0];
        $(t[1].slide, eo);
        d(e, "load error", s(g, t));
        P(e, "src", O(e, e$));
        P(e, "srcset", O(e, eS));
        B(e, e$);
        B(e, eS);
      }
      function g(t, e) {
        var i = t[0];
        var s = t[1];
        X(s.slide, eo);
        if (e.type !== "error") {
          R(t[2]);
          D(i, "");
          c(tk, i, s);
          c(tg);
        }
        if (u) {
          y();
        }
      }
      function y() {
        if (p.length) {
          m(p.shift());
        }
      }
      return {
        mount: function t() {
          if (o.lazyLoad) {
            f();
            a(tv, f);
          }
        },
        destroy: s(e, p),
        check: v
      };
    },
    Pagination: function t(n, o, r) {
      var a;
      var l;
      var d = tx(n);
      var c = d.on;
      var u = d.emit;
      var h = d.bind;
      var p = o.Slides;
      var f = o.Elements;
      var v = o.Controller;
      var m = v.hasFocus;
      var g = v.getIndex;
      var y = v.go;
      var b = o.Direction.resolve;
      var S = f.pagination;
      var E = [];
      function L() {
        _();
        c([tm, tv, "ei"], L);
        var t = r.pagination;
        if (S) {
          D(S, t ? "" : "none");
        }
        if (t) {
          c([th, tb, t$], A);
          (function t() {
            var e = n.length;
            var i = r.classes;
            var o = r.i18n;
            var d = r.perPage;
            var c = m() ? v.getEnd() + 1 : tt(e / d);
            a = S || T("ul", i.pagination, f.track.parentElement);
            $(a, l = tK + "--" + C());
            P(a, tT, "tablist");
            P(a, tN, o.select);
            P(a, tF, C() === "ttb" ? "vertical" : "");
            for (var u = 0; u < c; u++) {
              var g = T("li", null, a);
              var y = T("button", {
                class: i.page,
                type: "button"
              }, g);
              var b = p.getIn(u).map(function (t) {
                return t.slide.id;
              });
              var L = !m() && d > 1 ? o.pageX : o.slideX;
              h(y, "click", s(k, u));
              if (r.paginationKeyboard) {
                h(y, "keydown", s(x, u));
              }
              P(g, tT, "presentation");
              P(y, tT, "tab");
              P(y, tI, b.join(" "));
              P(y, tN, tr(L, u + 1));
              P(y, tq, -1);
              E.push({
                li: g,
                button: y,
                page: u
              });
            }
          })();
          A();
          u("pagination:mounted", {
            list: a,
            items: E
          }, w(n.index));
        }
      }
      function _() {
        if (a) {
          R(S ? i(a.children) : a);
          X(a, l);
          e(E);
          a = null;
        }
        d.destroy();
      }
      function k(t) {
        y(">" + t, true);
      }
      function x(t, e) {
        var i = E.length;
        var s = ey(e);
        var n = C();
        var o = -1;
        if (s === b(tM, false, n)) {
          o = ++t % i;
        } else if (s === b(tA, false, n)) {
          o = (--t + i) % i;
        } else if (s === "Home") {
          o = 0;
        } else if (s === "End") {
          o = i - 1;
        }
        var r = E[o];
        if (r) {
          I(r.button);
          y(">" + o);
          F(e, true);
        }
      }
      function C() {
        return r.paginationDirection || r.direction;
      }
      function w(t) {
        return E[v.toPage(t)];
      }
      function A() {
        var t = w(g(true));
        var e = w(g());
        if (t) {
          var i = t.button;
          X(i, ee);
          B(i, tH);
          P(i, tq, -1);
        }
        if (e) {
          var s = e.button;
          $(s, ee);
          P(s, tH, true);
          P(s, tq, "");
        }
        u("pagination:updated", {
          list: a,
          items: E
        }, t, e);
      }
      return {
        items: E,
        mount: L,
        destroy: _,
        getAt: w,
        update: A
      };
    },
    Sync: function t(i, n, o) {
      var r = o.isNavigation;
      var a = o.slideFocus;
      var l = [];
      function d() {
        var t;
        var e;
        i.splides.forEach(function (t) {
          if (!t.isParent) {
            u(i, t.splide);
            u(t.splide, i);
          }
        });
        if (r) {
          t = tx(i);
          e = t.on;
          e(tf, f);
          e("sk", v);
          e([tc, tm], p);
          l.push(t);
          t.emit(tE, i.splides);
        }
      }
      function c() {
        l.forEach(function (t) {
          t.destroy();
        });
        e(l);
      }
      function u(t, e) {
        var i = tx(t);
        i.on(th, function (t, i, s) {
          e.go(e.is(ep) ? s : t);
        });
        l.push(i);
      }
      function p() {
        P(n.Elements.list, tF, o.direction === "ttb" ? "vertical" : "");
      }
      function f(t) {
        i.go(t.index);
      }
      function v(t, e) {
        if (g(eL, ey(e))) {
          f(t);
          F(e);
        }
      }
      return {
        setup: s(n.Media.set, {
          slideFocus: h(a) ? r : a
        }, true),
        mount: d,
        destroy: c,
        remount: function t() {
          c();
          d();
        }
      };
    },
    Wheel: function t(e, i, s) {
      var n = tx(e).bind;
      var o = 0;
      function r(t) {
        if (t.cancelable) {
          var n;
          var r = t.deltaY;
          var a = r < 0;
          var l = U(t);
          var d = s.wheelMinThreshold || 0;
          var c = s.wheelSleep || 0;
          if (te(r) > d && l - o > c) {
            e.go(a ? "<" : ">");
            o = l;
          }
          n = a;
          if (!s.releaseWheel || e.state.is(4) || i.Controller.getAdjacent(n) !== -1) {
            F(t);
          }
        }
      }
      return {
        mount: function t() {
          if (s.wheel) {
            n(i.Elements.track, "wheel", r, em);
          }
        }
      };
    },
    Live: function t(e, i, n) {
      var o = tx(e).on;
      var r = i.Elements.track;
      var a = n.live && !n.isNavigation;
      var l = T("span", et);
      var d = tC(90, s(c, false));
      function c(t) {
        P(r, tV, t);
        if (t) {
          S(r, l);
          d.start();
        } else {
          R(l);
          d.cancel();
        }
      }
      function u(t) {
        if (a) {
          P(r, tz, t ? "off" : "polite");
        }
      }
      return {
        mount: function t() {
          if (a) {
            u(!i.Autoplay.isPaused());
            P(r, t3, true);
            l.textContent = "…";
            o(tL, s(u, true));
            o(t_, s(u, false));
            o([tp, t$], s(c, true));
          }
        },
        disable: u,
        destroy: function t() {
          B(r, [tz, t3, tV]);
          R(l);
        }
      };
    }
  });
  var ek = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5000,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: {
      slide: tU,
      clone: tG,
      arrows: t6,
      arrow: tY,
      prev: t5,
      next: t7,
      pagination: tK,
      page: tJ,
      spinner: tX + "spinner"
    },
    i18n: {
      prev: "Previous slide",
      next: "Next slide",
      first: "Go to first slide",
      last: "Go to last slide",
      slideX: "Go to slide %s",
      pageX: "Go to page %s",
      play: "Start autoplay",
      pause: "Pause autoplay",
      carousel: "carousel",
      slide: "slide",
      select: "Select a slide to show",
      slideLabel: "%s of %s"
    },
    reducedMotion: {
      speed: 0,
      rewindSpeed: 0,
      autoplay: "pause"
    }
  };
  function ex(t, e, i) {
    var s = e.Slides;
    function r() {
      s.forEach(function (t) {
        t.style("transform", "translateX(-" + t.index * 100 + "%)");
      });
    }
    return {
      mount: function e() {
        tx(t).on([tc, tv], r);
      },
      start: function t(e, o) {
        s.style("transition", "opacity " + i.speed + "ms " + i.easing);
        n(o);
      },
      cancel: o
    };
  }
  function eC(t, e, i) {
    var n;
    var o = e.Move;
    var r = e.Controller;
    var a = e.Scroll;
    var l = e.Elements.list;
    var d = s(q, l, "transition");
    function c() {
      d("");
      a.cancel();
    }
    return {
      mount: function e() {
        tx(t).bind(l, "transitionend", function (t) {
          if (t.target === l && n) {
            c();
            n();
          }
        });
      },
      start: function e(s, l) {
        var c = o.toPosition(s, true);
        var u = o.getPosition();
        var h = function e(s) {
          var n = i.rewindSpeed;
          if (t.is(eh) && n) {
            var o = r.getIndex(true);
            var a = r.getEnd();
            if (o === 0 && s >= a || o >= a && s === 0) {
              return n;
            }
          }
          return i.speed;
        }(s);
        if (te(c - u) >= 1 && h >= 1) {
          if (i.useScroll) {
            a.scroll(c, h, false, l);
          } else {
            d("transform " + h + "ms " + i.easing);
            o.translate(c, true);
            n = l;
          }
        } else {
          o.jump(s);
          l();
        }
      },
      cancel: c
    };
  }
  var ew = function () {
    function t(e, i) {
      this.event = tx();
      this.Components = {};
      this.state = function t(e) {
        var i = 1;
        function s(t) {
          i = t;
        }
        return {
          set: s,
          is: function t(e) {
            return g(v(e), i);
          }
        };
      }(1);
      this.splides = [];
      this._o = {};
      this._E = {};
      var s = u(e) ? z(document, e) : e;
      K(s, s + " is invalid.");
      this.root = s;
      i = A({
        label: O(s, tN) || "",
        labelledby: O(s, tR) || ""
      }, ek, t.defaults, i || {});
      try {
        A(i, JSON.parse(O(s, Y)));
      } catch (n) {
        K(false, "Invalid JSON");
      }
      this._o = Object.create(A({}, i));
    }
    var s = t.prototype;
    s.mount = function t(e, i) {
      var s = this;
      var n = this.state;
      var o = this.Components;
      K(n.is([1, 7]), "Already mounted!");
      n.set(1);
      this._C = o;
      this._T = i || this._T || (this.is(ef) ? ex : eC);
      this._E = e || this._E;
      var r = w({}, e_, this._E, {
        Transition: this._T
      });
      C(r, function (t, e) {
        var i = t(s, o, s._o);
        o[e] = i;
        if (i.setup) {
          i.setup();
        }
      });
      C(o, function (t) {
        if (t.mount) {
          t.mount();
        }
      });
      this.emit(tc);
      $(this.root, "is-initialized");
      n.set(3);
      this.emit(tu);
      return this;
    };
    s.sync = function t(e) {
      this.splides.push({
        splide: e
      });
      e.splides.push({
        splide: this,
        isParent: true
      });
      if (this.state.is(3)) {
        this._C.Sync.remount();
        e.Components.Sync.remount();
      }
      return this;
    };
    s.go = function t(e) {
      this._C.Controller.go(e);
      return this;
    };
    s.on = function t(e, i) {
      this.event.on(e, i);
      return this;
    };
    s.off = function t(e) {
      this.event.off(e);
      return this;
    };
    s.emit = function t(e) {
      var s;
      (s = this.event).emit.apply(s, [e].concat(i(arguments, 1)));
      return this;
    };
    s.add = function t(e, i) {
      this._C.Slides.add(e, i);
      return this;
    };
    s.remove = function t(e) {
      this._C.Slides.remove(e);
      return this;
    };
    s.is = function t(e) {
      return this._o.type === e;
    };
    s.refresh = function t() {
      this.emit(tv);
      return this;
    };
    s.destroy = function t(i = true) {
      var s = this.event;
      var n = this.state;
      if (n.is(1)) {
        tx(this).on(tu, this.destroy.bind(this, i));
      } else {
        C(this._C, function (t) {
          if (t.destroy) {
            t.destroy(i);
          }
        }, true);
        s.emit(tS);
        s.destroy();
        if (i) {
          e(this.splides);
        }
        n.set(7);
      }
      return this;
    };
    _createClass(t, [{
      key: "options",
      get: function t() {
        return this._o;
      },
      set: function t(e) {
        this._C.Media.set(e, true, true);
      }
    }, {
      key: "length",
      get: function t() {
        return this._C.Slides.getLength(true);
      }
    }, {
      key: "index",
      get: function t() {
        return this._C.Controller.getIndex();
      }
    }]);
    return t;
  }();
  ew.defaults = {};
  ew.STATES = {
    CREATED: 1,
    MOUNTED: 2,
    IDLE: 3,
    MOVING: 4,
    SCROLLING: 5,
    DRAGGING: 6,
    DESTROYED: 7
  };
  return ew;
});
class SplideComponent extends HTMLElement {
  constructor() {
    super();
    this.sliderContainer = this.querySelector(".splide");
    document.addEventListener("shopify:section:load", t => {
      this.initSlider();
    });
  }
  connectedCallback() {
    this.initSlider();
  }
  initSlider() {
    this.type = this.dataset.type || "slide";
    this.typeMobile = this.dataset.typeMobile || this.type;
    this.direction = this.dataset.direction || defaultDirection;
    this.rewind = this.type === "fade";
    this.autoplay = this.dataset.autoplay === "true";
    this.autoplaySpeed = this.dataset.autoplaySpeed && !isNaN(parseInt(this.dataset.autoplaySpeed)) ? parseInt(this.dataset.autoplaySpeed) * 1000 : 5000;
    this.drag = this.dataset.drag !== "false" && (this.dataset.drag !== "free" || "free");
    this.focus = this.dataset.focus || 0;
    this.trimSpace = this.dataset.trimSpace !== "false";
    this.arrows = this.dataset.arrows !== "false";
    this.arrowsColor = this.dataset.arrowsColor ? ` color-${this.dataset.arrowsColor}` : "";
    this.pagination = this.dataset.pagination !== "false";
    this.omitEnd = this.dataset.omitEnd !== "false";
    this.dotsColor = this.dataset.dotsColor ? ` color-${this.dataset.dotsColor} dots-custom-color` : "";
    this.slidesDesktop = this.dataset.slidesDesktop && !isNaN(parseInt(this.dataset.slidesDesktop)) ? parseInt(this.dataset.slidesDesktop) : 3;
    this.autoWidth = this.dataset.autoWidth === "true";
    this.slidesMobile = this.dataset.slidesMobile && !isNaN(parseInt(this.dataset.slidesMobile)) ? parseInt(this.dataset.slidesMobile) : 1;
    this.perMoveDesktop = this.dataset.perMoveDesktop && !isNaN(parseInt(this.dataset.perMoveDesktop)) ? parseInt(this.dataset.perMoveDesktop) : 1;
    this.perMoveMobile = this.dataset.perMoveMobile && !isNaN(parseInt(this.dataset.perMoveMobile)) ? parseInt(this.dataset.perMoveMobile) : 1;
    this.gapDesktop = this.dataset.gapDesktop ? parseInt(this.dataset.gapDesktop) : 30;
    this.gapMobile = this.dataset.gapMobile ? parseInt(this.dataset.gapMobile) : 15;
    this.paddingCalcDesktop = this.dataset.paddingCalcDesktop === "true";
    this.rightPaddingDesktop = parseInt(this.dataset.sidePaddingDesktop) || 0;
    this.leftPaddingDesktop = this.dataset.paddingCalcDesktop ? 0 : this.rightPaddingDesktop;
    this.paddingCalcMobile = this.dataset.paddingCalcMobile === "true";
    this.rightPaddingMobile = parseInt(this.dataset.sidePaddingMobile) || 0;
    this.leftPaddingMobile = this.paddingCalcMobile ? 0 : this.rightPaddingMobile;
    this.destroyDesktop = this.dataset.destroyDesktop === "true";
    this.destroyMobile = this.dataset.destroyMobile === "true";
    this.config = {
      type: this.type,
      direction: this.direction,
      rewind: this.rewind,
      autoplay: this.autoplay,
      interval: this.autoplaySpeed,
      drag: this.drag,
      focus: this.focus,
      trimSpace: this.trimSpace,
      arrows: this.arrows,
      pagination: this.pagination,
      omitEnd: this.omitEnd,
      perPage: this.slidesDesktop,
      perMove: this.perMoveDesktop,
      autoWidth: this.autoWidth,
      gap: this.gapDesktop,
      paddingCalc: this.paddingCalcDesktop,
      padding: {
        left: this.leftPaddingDesktop,
        right: this.rightPaddingDesktop
      },
      destroy: this.destroyDesktop,
      classes: {
        arrow: `splide__arrow${this.arrowsColor}`,
        page: `splide__pagination__page${this.dotsColor}`
      },
      easing: "cubic-bezier(0.25, 1, 0.5, 1)",
      breakpoints: {
        749: {
          omitEnd: this.omitEnd,
          type: this.typeMobile,
          perPage: this.slidesMobile,
          perMove: this.perMoveMobile,
          gap: this.gapMobile,
          paddingCalc: this.paddingCalcMobile,
          padding: {
            left: this.leftPaddingMobile,
            right: this.rightPaddingMobile
          },
          destroy: this.destroyMobile
        }
      }
    };
    let t = new Splide(this.sliderContainer, this.config);
    t.on("mounted", () => {
      let e = t.index;
      let i = t.Components.Elements.slides[e];
      if (i) {
        let s = i.querySelector("img");
        if (s) {
          if (s.complete) {
            i.classList.add("is-instant-active");
            this.setActiveSlideHeight(i);
          } else {
            s.addEventListener("load", () => {
              i.classList.add("is-instant-active");
              this.setActiveSlideHeight(i);
            });
          }
        } else {
          i.classList.add("is-instant-active");
          this.setActiveSlideHeight(i);
        }
      }
      let n = debounce(() => {
        let e = t.Components.Elements.slides[t.index];
        this.setActiveSlideHeight(e);
      }, 200);
      window.addEventListener("resize", n);
    });
    t.on("move", e => {
      let i = t.index;
      let s = t.Components.Elements.slides;
      if (s) {
        let n = s[i];
        if (n) {
          s.forEach(t => t.classList.remove("is-instant-active"));
          n.classList.add("is-instant-active");
          this.setActiveSlideHeight(n);
        }
      }
    });
    if (this.dataset.pauseVideos === "true") {
      t.on("hidden", t => {
        let e = t.slide.querySelector("internal-video");
        if (e) {
          let i = e.dataset.actionOnInactive;
          if (i === "pause") {
            e.video.pause();
            e.classList.remove("internal-video--playing");
          } else if (i === "mute") {
            e.video.muted = true;
            e.classList.add("internal-video--muted");
          }
        }
      });
    }
    t.mount();
  }
  setActiveSlideHeight(t) {
    if (t) {
      let e = t.offsetHeight;
      this.style.setProperty("--active-slide-height", `${e}px`);
    }
  }
}
customElements.define("splide-component", SplideComponent);
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content = this.mainDetailsToggle.querySelector("summary").nextElementSibling;
    this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }
  onToggle() {
    this.animations ||= this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach(t => t.play());
    } else {
      this.animations.forEach(t => t.cancel());
    }
  }
  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", false);
  }
}
customElements.define("details-disclosure", DetailsDisclosure);
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
  }
  onToggle() {
    if (this.header) {
      this.header.preventHide = this.mainDetailsToggle.open;
      if (document.documentElement.style.getPropertyValue("--header-bottom-position-desktop") === "") {
        document.documentElement.style.setProperty("--header-bottom-position-desktop", `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
      }
    }
  }
}
customElements.define("header-menu", HeaderMenu);
class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.detailsContainer.addEventListener("keyup", t => t.code.toUpperCase() === "ESCAPE" && this.close());
    this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this));
    this.querySelector("button[type=\"button\"]").addEventListener("click", this.close.bind(this));
    this.summaryToggle.setAttribute("role", "button");
  }
  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }
  onSummaryClick(t) {
    t.preventDefault();
    if (t.target.closest("details").hasAttribute("open")) {
      this.close();
    } else {
      this.open(t);
    }
  }
  onBodyClick(t) {
    if (!this.contains(t.target) || t.target.classList.contains("modal-overlay")) {
      this.close(false);
    }
  }
  open(t) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    t.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");
    if (typeof trapFocus == "function") {
      trapFocus(this.detailsContainer.querySelector("[tabindex=\"-1\"]"), this.detailsContainer.querySelector("input:not([type=\"hidden\"])"));
    }
  }
  close(t = true) {
    if (typeof removeTrapFocus == "function") {
      removeTrapFocus(t ? this.summaryToggle : null);
    }
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
  }
}
customElements.define("details-modal", DetailsModal);
let hotspotButtons = [];
function registerHotspotButton(t) {
  hotspotButtons.push(t);
}
function unregisterHotspotButton(t) {
  let e = hotspotButtons.indexOf(t);
  if (e !== -1) {
    hotspotButtons.splice(e, 1);
  }
}
document.addEventListener("mousedown", function (t) {
  for (let e of hotspotButtons) {
    if (e.dataset.open === "true" && !e.contains(t.target)) {
      e.closeModal();
    }
  }
});
class HotspotButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".hotspot-btn");
    this.content = this.querySelector(".hotspot__content");
    this.type = this.dataset.type;
    this.openEvent = this.dataset.openEvent;
    this.header = document.querySelector(".section-header");
    this.stickyHeader = document.querySelector("sticky-header");
    this.mobileOverlay = this.querySelector(".hotspot-overlay");
    this.button.addEventListener("click", this.toggleModal.bind(this));
    if (this.openEvent === "hover" && window.matchMedia("(hover: hover)").matches && window.matchMedia("(pointer: fine)").matches) {
      this.button.addEventListener("mouseover", this.openModal.bind(this));
      this.button.addEventListener("mouseout", this.startCheckingMouseLeave.bind(this));
      this.content.addEventListener("mouseover", this.stopCheckingMouseLeave.bind(this));
      this.content.addEventListener("mouseout", this.startCheckingMouseLeave.bind(this));
    }
    if (this.mobileOverlay) {
      this.mobileOverlay.addEventListener("click", this.closeModal.bind(this));
    }
  }
  startCheckingMouseLeave() {
    this.checkingMouseLeave = true;
    setTimeout(() => {
      if (this.checkingMouseLeave) {
        this.closeModal();
      }
    }, 200);
  }
  stopCheckingMouseLeave() {
    this.checkingMouseLeave = false;
  }
  toggleModal() {
    if (this.dataset.open != "true") {
      this.openModal();
    }
  }
  openModal() {
    let t = this.header.clientHeight;
    if (this.header.classList.contains("shopify-section-header-hidden") || !this.stickyHeader) {
      t = 0;
    }
    if (this.content.getBoundingClientRect().top - t < 0) {
      this.dataset.direction = "bottom";
    }
    this.dataset.open = "true";
  }
  closeModal() {
    this.dataset.open = "false";
    setTimeout(() => {
      this.dataset.direction = "";
    }, 100);
  }
  connectedCallback() {
    registerHotspotButton(this);
  }
  disconnectedCallback() {
    unregisterHotspotButton(this);
  }
}
customElements.define("hotspot-button", HotspotButton);
class ParallaxHero extends HTMLElement {
  constructor() {
    super();
    this.overlays = this.querySelectorAll(".parallax-hero__layer");
    this.animateOnEnter = this.dataset.animationStart === "bottom";
    this.handleScroll();
    window.addEventListener("scroll", () => requestAnimationFrame(this.handleScroll.bind(this)));
  }
  handleScroll(t) {
    var {
      top: e,
      left: i,
      height: s
    } = this.getBoundingClientRect();
    let n = window.innerHeight;
    let o;
    if (this.animateOnEnter) {
      if (e > n || e + s < 0) {
        return;
      }
      o = Math.min((n - e) / (n + s), 1);
    } else {
      if (e > n || e + s < 0) {
        return;
      }
      let r = e >= 0 ? 0 : -e;
      if (r > s) {
        return;
      }
      o = Math.min(r / s, 1);
    }
    this.overlays.forEach(t => {
      let i = e * (parseInt(t.dataset.scrollY) / 100);
      let s = parseInt(t.dataset.scrollX) * o;
      let n = 100 + (parseInt(t.dataset.zoom) - 100) * o;
      let r = parseInt(t.dataset.rotation) * 3.6 * o;
      t.style.transform = `translateY(${i}px) translateX(${s}%) scale(${n / 100}) rotate(${r}deg)`;
    });
  }
}
customElements.define("parallax-hero", ParallaxHero);
class ContentTabs extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll(".content-tab-button");
    this.tabs = this.querySelectorAll(".content-tab");
    this.tabsContainer = this.querySelector(".content-tabs__tabs");
    this.activeButton = this.querySelector(".content-tab-button--active");
    this.activeTab = this.querySelector(".content-tab--active");
    this.isMovingAnimation = this.dataset.animation === "moving";
    if (this.isMovingAnimation) {
      this.activeBg = this.querySelector(".content-tab-buttom__active-bg");
      this.handleActiveBg();
      this.activeBg.style.transitionDuration = "0.4s";
    }
    this.setHeight();
    this.buttons.forEach(t => {
      t.addEventListener("click", this.handleClick.bind(this));
    });
    window.addEventListener("resize", () => {
      this.setHeight();
      if (this.isMovingAnimation) {
        this.handleActiveBg();
      }
    });
  }
  handleClick(t) {
    this.activeButton = t.currentTarget;
    this.buttons.forEach(t => {
      t.classList.remove("content-tab-button--active");
    });
    this.activeButton.classList.add("content-tab-button--active");
    this.tabs.forEach(t => {
      t.classList.remove("content-tab--active");
      if (t.dataset.index === this.activeButton.dataset.index) {
        this.activeTab = t;
      }
    });
    this.activeTab.classList.add("content-tab--active");
    this.setHeight();
    if (this.isMovingAnimation) {
      this.handleActiveBg();
    }
  }
  setHeight() {
    if (this.activeTab) {
      this.tabsContainer.style.height = this.activeTab.clientHeight + "px";
    }
  }
  handleActiveBg() {
    this.activeBg.style.width = this.activeButton.getBoundingClientRect().width + "px";
    this.activeBg.style.height = this.activeButton.getBoundingClientRect().height + "px";
    this.activeBg.style.top = this.activeButton.offsetTop + "px";
    this.activeBg.style.left = this.activeButton.offsetLeft + "px";
  }
}
customElements.define("content-tabs", ContentTabs);
class InstaStories extends HTMLElement {
  constructor() {
    super();
    this.openButtons = this.querySelectorAll(".insta-story-open-btn");
    this.openButtonsOverflowContainer = this.querySelector(".insta-stories__open-buttons-container");
    this.openButtonsContainer = this.querySelector(".insta-stories__open-buttons");
    this.openBtnsPrev = this.querySelector(".insta-stories__open-btns-prev");
    this.openBtnsNext = this.querySelector(".insta-stories__open-btns-next");
    this.closeButtons = this.querySelectorAll(".insta-stories__close-button");
    this.modal = this.querySelector(".insta-stories__modal");
    this.modalOpen = false;
    this.slider = this.querySelector(".insta-stories__slider");
    this.stories = this.querySelectorAll(".insta-story");
    this.prevBtns = this.querySelectorAll(".insta-story__prev");
    this.nextBtns = this.querySelectorAll(".insta-story__next");
    this.slideBtns = this.querySelectorAll(".insta-story__slide-btn");
    this.activeIndex = 0;
    this.activeStory = this.stories[this.activeIndex];
    this.lastIndex = parseInt(this.dataset.lastIndex);
    this.pauseResumeBtns = this.querySelectorAll(".insta-story__pause-resume-btn");
    this.isPaused = false;
    this.volumeBtns = this.querySelectorAll(".insta-story__volume-btn");
    this.isMuted = true;
    this.initStories();
    this.initButtonsSlider();
    this.openButtons.forEach(t => {
      t.addEventListener("click", this.openModal.bind(this));
    });
    this.closeButtons.forEach(t => {
      t.addEventListener("click", this.closeModal.bind(this));
    });
    this.prevBtns.forEach(t => {
      t.addEventListener("click", this.storyPrevBtnClick.bind(this));
    });
    this.nextBtns.forEach(t => {
      t.addEventListener("click", this.storyNextBtnClick.bind(this));
    });
    this.slideBtns.forEach(t => {
      t.addEventListener("click", this.slideBtnClick.bind(this));
    });
    this.pauseResumeBtns.forEach(t => {
      t.addEventListener("click", this.togglePauseResume.bind(this));
    });
    this.volumeBtns.forEach(t => {
      t.addEventListener("click", this.toggleIsMuted.bind(this));
    });
    this.slider.addEventListener("touchstart", this.touchStartHandler.bind(this));
    this.slider.addEventListener("touchend", this.touchEndHandler.bind(this));
    document.addEventListener("keydown", t => {
      if (this.modalOpen) {
        switch (t.key) {
          case "Escape":
            this.closeModal();
            break;
          case "ArrowLeft":
            this.storyPrevBtnClick();
            break;
          case "ArrowRight":
            this.storyNextBtnClick();
        }
      }
    });
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", () => {
        this.initStories();
        this.initButtonsSlider();
      });
      document.addEventListener("shopify:section:reorder", () => {
        this.initStories();
        this.initButtonsSlider();
      });
    }
  }
  autoplay() {
    let t = this.activeStory;
    let e = parseInt(t.dataset.activeMediaIndex);
    let i = t.querySelectorAll(".insta-story__media")[e];
    let s = parseInt(i.getAttribute("data-duration")) * 1000;
    this.updateProgressBars(e);
    this.autoplayStartTime = Date.now();
    this.autoplayTimeout = setTimeout(() => {
      this.storyNextBtnClick();
    }, s);
  }
  storyPrevBtnClick() {
    let t = this.activeStory;
    if (t.dataset.activeMediaIndex === "0") {
      this.changeActiveStory(this.activeIndex - 1);
    } else {
      this.changeActiveMedia(parseInt(t.dataset.activeMediaIndex) - 1);
    }
  }
  storyNextBtnClick() {
    let t = this.activeStory;
    if (t.dataset.activeMediaIndex === t.dataset.lastMediaIndex) {
      this.changeActiveStory(this.activeIndex + 1);
    } else {
      this.changeActiveMedia(parseInt(t.dataset.activeMediaIndex) + 1);
    }
  }
  slideBtnClick(t) {
    let e = parseInt(t.currentTarget.dataset.index);
    this.changeActiveStory(e);
  }
  changeActiveStory(t) {
    clearTimeout(this.autoplayTimeout);
    if (t > this.lastIndex || t < 0) {
      return;
    }
    let e = this.stories[this.activeIndex];
    let i = parseInt(e.dataset.activeMediaIndex);
    if (e.dataset.played === "true" || i > 0) {
      let s = e.querySelectorAll(".insta-story__progress-item")[i];
      if (s) {
        s.classList.remove("insta-story__progress-item--active");
        if (t > this.activeIndex) {
          s.classList.add("insta-story__progress-item--completed");
        }
      }
    }
    let n = e.querySelectorAll(".insta-story__media")[i];
    if (n && n.getAttribute("data-type") === "video") {
      let o = n.querySelector("video");
      if (o) {
        o.pause();
        if (!this.isPaused) {
          o.currentTime = 0;
        }
      }
    }
    this.activeIndex = t;
    this.activeStory = this.stories[this.activeIndex];
    this.stories.forEach(t => {
      t.classList.remove("insta-story--active");
    });
    this.activeStory.classList.add("insta-story--active");
    this.activeStory.dataset.played = "true";
    this.slider.style.transform = `translateX(calc(var(--story-width) * ${this.activeIndex * (isRtl ? 1 : -1)}))`;
    let r = parseInt(this.activeStory.dataset.activeMediaIndex, 10);
    this.changeActiveMedia(r);
    this.updateProgressBars(r);
  }
  changeActiveMedia(t) {
    clearTimeout(this.autoplayTimeout);
    if (t < 0) {
      return;
    }
    let e = this.activeStory;
    let i = parseInt(e.dataset.lastMediaIndex);
    if (t > i) {
      return;
    }
    e.dataset.activeMediaIndex = t;
    let s = e.querySelectorAll(".insta-story__media");
    for (let n = 0; n < s.length; n++) {
      if (n === t) {
        s[n].style.display = "block";
        if (s[n].getAttribute("data-type") === "video") {
          let o = s[n].querySelector("video");
          if (o && !this.isPaused) {
            o.play();
          }
        }
        e.querySelector(".insta-story__time-posted").innerHTML = s[n].dataset.timePosted;
      } else {
        s[n].style.display = "";
        if (s[n].getAttribute("data-type") === "video") {
          let r = s[n].querySelector("video");
          if (r) {
            r.pause();
            if (!this.isPaused) {
              r.currentTime = 0;
            }
          }
        }
      }
    }
    this.updateProgressBars(t);
    if (!this.isPaused) {
      this.autoplay();
    }
    let a = e.querySelectorAll(".insta-story__prev");
    let l = e.querySelectorAll(".insta-story__next");
    a.forEach(e => {
      if (this.activeIndex === 0 && t === 0) {
        e.setAttribute("disabled", "");
      } else {
        e.removeAttribute("disabled");
      }
    });
    l.forEach(e => {
      if (this.activeIndex === this.lastIndex && t === i) {
        e.setAttribute("disabled", "");
      } else {
        e.removeAttribute("disabled");
      }
    });
  }
  updateProgressBars(t) {
    let e = this.activeStory;
    let i = e.querySelectorAll(".insta-story__progress-item");
    i.forEach((e, i) => {
      e.classList.remove("insta-story__progress-item--completed", "insta-story__progress-item--active");
      if (i < t) {
        e.classList.add("insta-story__progress-item--completed");
      } else if (i === t) {
        e.classList.add("insta-story__progress-item--active");
      }
    });
  }
  openModal(t) {
    window.scrollBy(0, -1);
    this.modal.dataset.open = "true";
    this.modalOpen = true;
    document.body.classList.add("overflow-hidden");
    this.changeActiveStory(parseInt(t.currentTarget.dataset.index));
  }
  closeModal(t) {
    this.querySelectorAll("video").forEach(t => {
      t.pause();
    });
    this.modal.dataset.open = "false";
    this.modalOpen = false;
    document.body.classList.remove("overflow-hidden");
    clearTimeout(this.autoplayTimeout);
  }
  initButtonsSlider() {
    if (this.openButtonsOverflowContainer.clientWidth > this.openButtonsContainer.clientWidth) {
      return;
    }
    let t = () => "ontouchstart" in window || navigator.maxTouchPoints;
    let e;
    let i = 0;
    let s = 0;
    let n = t => {
      this.openButtonsContainer.style.transform = `translateX(${t}px)`;
      i = t;
    };
    this.openButtonsOverflowContainer.addEventListener("touchstart", t => {
      this.isDragging = true;
      e = t.touches[0].clientX - s;
    });
    this.openButtonsOverflowContainer.addEventListener("touchmove", t => {
      if (!this.isDragging) {
        return;
      }
      let i = t.touches[0].clientX;
      let s = i - e;
      if (s < 0 && Math.abs(s) <= this.openButtonsContainer.offsetWidth - this.openButtonsOverflowContainer.offsetWidth) {
        n(s);
      }
    });
    this.openButtonsOverflowContainer.addEventListener("touchend", () => {
      this.isDragging = false;
      s = i;
    });
    let o = parseFloat(getComputedStyle(this.openButtons[0]).width);
    let r = parseFloat(getComputedStyle(this.openButtonsContainer).columnGap);
    let a = () => {
      let t = Math.floor(this.openButtonsOverflowContainer.clientWidth / (o + r));
      return (t - 1) * (o + r);
    };
    let l = isRtl ? -1 : 1;
    let d = () => {
      let t = this.openButtonsOverflowContainer.scrollLeft * l;
      this.openBtnsPrev.style.display = t <= 0 ? "none" : "grid";
      this.openBtnsNext.style.display = t > this.openButtonsOverflowContainer.scrollWidth - this.openButtonsContainer.clientWidth ? "none" : "grid";
    };
    this.openBtnsPrev.addEventListener("click", () => {
      this.openButtonsOverflowContainer.scrollBy({
        left: -a() * l,
        behavior: "smooth"
      });
      setTimeout(d, 300);
    });
    this.openBtnsNext.addEventListener("click", () => {
      this.openButtonsOverflowContainer.scrollBy({
        left: a() * l,
        behavior: "smooth"
      });
      setTimeout(d, 300);
    });
    d();
    if (t()) {
      this.openBtnsPrev.style.display = "none";
      this.openBtnsNext.style.display = "none";
    }
    window.addEventListener("resize", debounce(() => {
      if (this.openButtonsOverflowContainer.clientWidth <= this.openButtonsContainer.clientWidth) {
        if (t()) {
          this.openBtnsPrev.style.display = "none";
          this.openBtnsNext.style.display = "none";
        } else {
          d();
        }
      } else {
        this.openBtnsPrev.style.display = "none";
        this.openBtnsNext.style.display = "none";
      }
    }, 250));
  }
  initStories() {
    this.stories.forEach(t => {
      let e = t.querySelectorAll(".insta-story__media");
      t.dataset.lastMediaIndex = e.length - 1;
      t.dataset.played = "false";
      let i = t.querySelector(".insta-story__progress");
      for (let s = 0; s < e.length; s++) {
        let n = e[s].getAttribute("data-duration");
        let o = document.createElement("span");
        o.className = "insta-story__progress-item";
        o.style.setProperty("--duration", `${n}s`);
        let r = document.createElement("span");
        r.className = "insta-story__progress-bar";
        o.appendChild(r);
        i.appendChild(o);
      }
      let a = parseInt(t.dataset.activeMediaIndex);
      if (e[a]) {
        e[a].style.display = "block";
      }
    });
  }
  togglePauseResume(t) {
    let e = t.currentTarget.getAttribute("data-paused") === "true";
    if (e) {
      this.resumeStory();
    } else {
      this.pauseStory();
    }
    this.pauseResumeBtns.forEach(t => {
      t.setAttribute("data-paused", e ? "false" : "true");
    });
  }
  pauseStory() {
    this.isPaused = true;
    let t = this.activeStory.querySelectorAll(".insta-story__media")[parseInt(this.activeStory.dataset.activeMediaIndex)];
    let e = parseInt(t.getAttribute("data-duration")) * 1000;
    this.remainingTime = e - (Date.now() - this.autoplayStartTime);
    clearTimeout(this.autoplayTimeout);
    if (t.getAttribute("data-type") === "video") {
      let i = t.querySelector("video");
      if (i) {
        i.pause();
      }
    }
    let s = this.querySelectorAll(".insta-story__progress-bar");
    s.forEach(t => {
      t.style.animationPlayState = "paused";
    });
  }
  resumeStory() {
    this.isPaused = false;
    let t = this.querySelectorAll(".insta-story__progress-bar");
    t.forEach(t => {
      t.style.animationPlayState = "running";
    });
    let e = this.activeStory.querySelectorAll(".insta-story__media")[parseInt(this.activeStory.dataset.activeMediaIndex)];
    if (e.getAttribute("data-type") === "video") {
      let i = e.querySelector("video");
      if (i) {
        i.play();
      }
    }
    this.autoplayStartTime = Date.now();
    this.autoplayTimeout = setTimeout(() => {
      this.storyNextBtnClick();
    }, this.remainingTime);
  }
  toggleIsMuted(t) {
    t.currentTarget;
    this.isMuted = !this.isMuted;
    let e = this.querySelectorAll("video");
    e.forEach(t => {
      t.muted = this.isMuted;
    });
    this.volumeBtns.forEach(t => {
      if (this.isMuted) {
        t.setAttribute("data-muted", "true");
      } else {
        t.setAttribute("data-muted", "false");
      }
    });
  }
  touchStartHandler(t) {
    this.touchStartX = t.touches[0].clientX;
  }
  touchEndHandler(t) {
    let e = t.changedTouches[0].clientX;
    let i = e - this.touchStartX;
    if (Math.abs(i) < 50) {
      return;
    }
    let s = isRtl ? -1 : 1;
    if (i < 0) {
      if (this.activeIndex < this.lastIndex) {
        this.changeActiveStory(this.activeIndex + s);
      }
    } else if (this.activeIndex > 0) {
      this.changeActiveStory(this.activeIndex - s);
    }
  }
}
customElements.define("insta-stories", InstaStories);
class TncCheckbox extends HTMLElement {
  constructor() {
    super();
    this.checked = false;
    this.checkoutButton = document.querySelector("#CartDrawer-Checkout");
    this.disableButton = this.dataset.disableButton === "true";
    this.warningText = this.dataset.warningText;
    this.warningTextElement = document.querySelector(`.tnc-checkbox-warning--${this.dataset.warningPosition}`);
    if (!this.checkoutButton || !this.warningTextElement) {
      return;
    }
    if (this.warningTextElement) {
      this.warningTextElement.innerHTML = this.warningText;
    }
    if (this.disableButton) {
      this.checkoutButton.classList.add("disabled");
    }
    this.addEventListener("click", this.handleCheckboxClick.bind(this));
    this.checkoutButton.addEventListener("click", this.handleButtonClick.bind(this));
  }
  handleCheckboxClick(t) {
    this.checked = !this.checked;
    this.dataset.checked = this.checked;
    if (this.checked) {
      this.warningTextElement.classList.add("hidden");
      if (this.disableButton) {
        this.checkoutButton.classList.remove("disabled");
      }
    } else if (this.disableButton) {
      this.checkoutButton.classList.add("disabled");
    }
  }
  handleButtonClick(t) {
    if (this.checked !== true) {
      t.preventDefault();
      this.warningTextElement.classList.remove("hidden");
    }
  }
}
customElements.define("tnc-chekcbox", TncCheckbox);
class ContactForm extends HTMLElement {
  constructor() {
    super();
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleFieldInput = this.handleFieldInput.bind(this);
  }
  connectedCallback() {
    this.form = this.querySelector("form");
    if (this.form) {
      this.requiredFields = Array.from(this.querySelectorAll(".field-wrapper[data-required=\"true\"]"));
      if (this.requiredFields.length > 0) {
        this.form.addEventListener("submit", this.handleFormSubmit);
        this.requiredFields.forEach(t => {
          let e = t.querySelector(".field__input, .text-area");
          if (e) {
            e.addEventListener("input", this.handleFieldInput);
          }
        });
      }
    }
  }
  disconnectedCallback() {
    if (this.form) {
      this.form.removeEventListener("submit", this.handleFormSubmit);
    }
    this.requiredFields.forEach(t => {
      let e = t.querySelector(".field__input, .text-area");
      if (e) {
        e.removeEventListener("input", this.handleFieldInput);
      }
    });
  }
  handleFormSubmit(t) {
    let e = true;
    this.requiredFields.forEach(t => {
      let i = t.querySelector(".field__input, .text-area");
      let s = t.querySelector(".field-wrapper__error-msg");
      if (i && !i.value.trim()) {
        e = false;
        t.classList.add("field-wrapper--error");
        if (s) {
          s.classList.remove("hidden");
        }
      }
    });
    if (!e) {
      t.preventDefault();
    }
  }
  handleFieldInput(t) {
    let e = t.target;
    let i = e.closest(".field-wrapper");
    let s = i.querySelector(".field-wrapper__error-msg");
    i.classList.remove("field-wrapper--error");
    if (s) {
      s.classList.add("hidden");
    }
  }
}
customElements.define("contact-form", ContactForm);
